import '../../css/mobile/MUserMyPg.css';
import MFooterSection from "../../components/mobile/MFooterSection";
import MHeader from "../../components/mobile/MHeader";
import mypgPayinfo from "../../assets/img/mypgPayinfo.png";
import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import profileImage from '../../assets/img/profileDefaultImg.png'
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import commonHeader from "../../assets/img/commonHeader.png";
import mypgOrder from "../../assets/img/mypgOrder.png";
import MyPageProcessNext from "../../assets/img/MyPageProcessNext.png";
import mypgDelivery from "../../assets/img/mypgDelivery.png";
import mypgReturnIcon from "../../assets/img/mypgReturnIcon.png";
import CommonLoading from "../../components/web/modal/CommonLoading";
import IntegDetailPopup from "../../components/web/modal/IntegDetailPopup";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import Expand from "../../assets/img/commonBottom.png";
import mypgPayCardOrder from "../../assets/img/mypgPayCardOrder.png";
import noData from "../../assets/img/noData.png";
import mypgWarn from "../../assets/img/mypgWarn.png";
import commonClose from "../../assets/img/commonClose.png";
import mypgOrderdt from "../../assets/img/mypgOrderdt.png";
import mypgPayCardDelivery from "../../assets/img/mypgPayCardDelivery.png";
import MDeliveryPriceDetail from "../../components/mobile/MDeliveryPriceDetail";
import {useWebSocket} from "../../services/WebsocketContext";
import withAuth from "../../auth/UserRouteAuth";
import i18n from "../../i18n";
import {useChat} from "../../components/contextApi/ChatContext";

const MUserMyPg = () => {
    const subTitle = (title, img) => {

        return (
            <div className='m-a-user-my-page-sub-title'>
                <img className='m-a-user-my-page-sub-title-icon' src={img} alt=''/>
                <div className='m-a-user-my-page-sub-title-text'>{title}</div>
            </div>
        )
    }

    useEffect(() => {
        setOrderTypeSelectCommonValue(t('orderType'))
        setOrderStSelectCommonValue(t(`state`));
        setPeriodSelectCommonValue(t('myPrd1'))
        setPayStSelectCommonValue(t(`state`));
        setPayPeriodSelectCommonValue(t('myPrd1'))
        setDacPeriodSelectCommonValue(t('myPrd1'))
    }, [i18n.language]);

    const {t} = useTranslation();
    const navigate = useNavigate();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    // 주문서 기간셀렉트
    const [periodSelectShow, setPeriodSelectShow] = useState(false);
    const [periodSelectCommonValue, setPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const periodButtonRef = useRef(null);
    const periodDivRef = useRef(null);

    const periodBtHandle = (newValue) => {
        setPeriodSelectShow(false);
        setPeriodSelectCommonValue(newValue);
    };
    const periodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const periodClickOutside = (event) => {
            if (
                periodButtonRef.current &&
                periodButtonRef.current.contains(event.target)
            ) {
                setPeriodSelectShow(true);
            } else if (
                periodDivRef.current &&
                !periodDivRef.current.contains(event.target)
            ) {
                setPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', periodClickOutside);
        return () => {
            document.removeEventListener('mousedown', periodClickOutside);
        };
    }, []);

    // 주문서 유형셀렉트
    const [orderTypeSelectShow, setOrderTypeSelectShow] = useState(false);
    const [orderTypeSelectCommonValue, setOrderTypeSelectCommonValue] = useState(t(`orderType`));
    const orderTypeButtonRef = useRef(null);
    const orderTypeDivRef = useRef(null);

    const orderTypeBtHandle = (newValue) => {
        setOrderTypeSelectShow(false);
        setOrderTypeSelectCommonValue(newValue);
    };
    const orderTypeDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const orderTypeClickOutside = (event) => {
            if (
                orderTypeButtonRef.current &&
                orderTypeButtonRef.current.contains(event.target)
            ) {
                setOrderTypeSelectShow(true);
            } else if (
                orderTypeDivRef.current &&
                !orderTypeDivRef.current.contains(event.target)
            ) {
                setOrderTypeSelectShow(false);
            }
        };
        document.addEventListener('mousedown', orderTypeClickOutside);
        return () => {
            document.removeEventListener('mousedown', orderTypeClickOutside);
        };
    }, []);

    // 주문서 상태셀렉트
    const [orderStSelectShow, setOrderStSelectShow] = useState(false);
    const [orderStSelectCommonValue, setOrderStSelectCommonValue] = useState(t(`state`));
    const orderStButtonRef = useRef(null);
    const orderStDivRef = useRef(null);

    const myPgContentRef = useRef(null);
    const scrollToMyPgContent = () => {
        if (myPgContentRef.current) {
            myPgContentRef?.current.scrollIntoView({behavior: 'smooth'});
        }
    };

    const orderStBtHandle = (newValue) => {
        setOrderStSelectShow(false);
        setOrderStSelectCommonValue(newValue);
        filterOrderSt(newValue);
        scrollToMyPgContent();
    };
    const orderStDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const orderStClickOutside = (event) => {
            if (
                orderStButtonRef.current &&
                orderStButtonRef.current.contains(event.target)
            ) {
                setOrderStSelectShow(true);
            } else if (
                orderStDivRef.current &&
                !orderStDivRef.current.contains(event.target)
            ) {
                setOrderStSelectShow(false);
            }
        };
        document.addEventListener('mousedown', orderStClickOutside);
        return () => {
            document.removeEventListener('mousedown', orderStClickOutside);
        };
    }, []);
    const [memberInfo, setMemberInfo] = useState([{}]);
    const [memberDto, setMemberDto] = useState([]);
    const selectMember = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberDto(response.data[0]);
                setProfileName(response.data[0].userName)
                setMemberInfo(response.data)

                if (response.data && response.data[0] && response.data[0].profileDTO && response.data[0].profileDTO.filename) {
                    setProfilePhotoLine("https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + response.data[0].profileDTO.filename)
                } else {
                    setProfilePhotoLine(profileImage)
                }
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (LCAT || SSAT) {
            selectMember();
        }
    }, [LCAT, SSAT])

    const memberDtoRef = useRef(memberDto);
    useEffect(() => {
        memberDtoRef.current = memberDto;
    }, [memberDto])

    useEffect(() => {
        if (memberDto && memberDto.mbNum) {
            selectTotalUnreadCount(memberDto.mbNum);
        }
    }, [memberDto]);

    const { totalUnreadCount, setTotalUnreadCount } = useChat();
    const selectTotalUnreadCount = (mbNum) => {
        axios.get(`/order/selectTotalUnreadCount/${mbNum}`, {
            headers: {
                Authorization: SSAT ? SSAT : LCAT
            }
        })
            .then(response => {
                setTotalUnreadCount(response.data);
            })
            .catch(error => {
                console.log(error);
            })
    }

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberDto.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(memberDto.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                subscribe(`/user/${memberDto.mbNum}/queue/adminMessage`, onMessageReceived);
                subscribe(`/user/${memberDto.mbNum}/queue/adminChatUpdate`, onChatAdminUpdate);
                subscribe(`/user/${memberDto.mbNum}/queue/adminOrderStUpdate`, receivedOrderStChange);
                subscribe(`/user/${memberDto.mbNum}/queue/adminOrderDivideMerge`, receivedOrderDivideMerge);
                subscribe(`/user/${memberDto.mbNum}/queue/adminUpdateOrder`, updateOrderList);
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminMessage`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminChatUpdate`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminOrderStUpdate`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminOrderDivideMerge`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminUpdateOrder`);
                isSubscribedRef.current = false;
            }
        };

    }, [memberDto.mbNum, isConnected, stompClient]);

    const onMessageReceived = async (payload) => {
        let newMessage = JSON.parse(payload.body);
        if (newMessage.mstMbNum === memberDtoRef.current.mbNum && newMessage.memberDTO.role === '1') {
            selectTotalUnreadCount();
        }
    }

    const onChatAdminUpdate = ((payload) => {
        selectTotalUnreadCount();
    })

    const [orderdtList, setOrderdtList] = useState([{}]);
    const [productsList, setProductsList] = useState([]);
    const [payinfoList, setPayinfoList] = useState([{}]);
    const [recinfoList, setRecinfoList] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);

    const selectTotalOrderList = ((date) => {
        setIsLoading(true);

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(date)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(date)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(date)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(date)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(date)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/selectTotalOrderList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate,
            },
        })
            .then((response) => {
                // let sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                // sortedData = sortedData.slice(0, 10);
                setOrderdtList(response.data);

                const ProdList = response.data.map(order => {
                    const productMap = new Map();
                    order.productsDTO.forEach(product => {
                        if (!productMap.has(product.seqnum)) {
                            productMap.set(product.seqnum, product);
                        }
                    });
                    return Array.from(productMap.values());
                });
                setProductsList(ProdList);

                const payList = response.data.flatMap(order => order.payInfoDTO);
                setPayinfoList(payList);

                const recList = response.data.map(order => order.recinfoDTO);
                setRecinfoList(recList);

            })
            .catch(() => {
            })
            .finally(() => {
                setIsLoading(false);
            })
    })

    useEffect(() => {
        selectTotalOrderList(periodSelectCommonValue);
    }, [periodSelectCommonValue]);

    const myOrdPgMove = (ordNum) => () => {
        navigate(`/UserMyOrderPg/${ordNum}`);
    };

    const [paySeqnum, setPaySeqnum] = useState(null);
    const [payShipco, setPayShipco] = useState('');
    const [deliveryDetailSt, setDeliveryDetailSt] = useState(false);
    const deliveryDetailFalseFn = (() => {
        setDeliveryDetailSt(false);
    })
    const deliveryDetailTrueFn = ((seqNum, shipco) => {
        setPaySeqnum(seqNum);
        setPayShipco(shipco);
        setDeliveryDetailSt(true);
    })

    const updateAppRecinfo = (updatedPayinfo) => {
        setFilteredList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) => {
                if (payinfo.appRecDTO && payinfo.appRecDTO.seqnum === updatedPayinfo.seqnum) {
                    return {...payinfo, appRecDTO: updatedPayinfo};
                }
                return payinfo;
            });
        });
    };

    const updatePayinfoList = (updatedPayinfo) => {
        setPayinfoList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) =>
                payinfo.seqNum === updatedPayinfo.seqNum ? updatedPayinfo : payinfo,
            );
        });
    };

    const receivedOrderStChange = ((payload) => {
        let data = JSON.parse(payload.body);
        setFilteredList(prevList => {
            return prevList.map(item => {
                // 조건에 맞는 항목 찾기
                if (item.type === 'orderdt' && item.seqnum === data.orderSeqNum) {
                    // 해당 항목의 orderStatus를 data.orderSt로 업데이트
                    return {
                        ...item,
                        orderStatus: data.orderSt
                    };
                }
                // 다른 항목들은 그대로 유지
                return item;
            });
        });
    });

    const receivedOrderDivideMerge = ((payload) => {
        let data = JSON.parse(payload.body);
        selectTotalOrderList(periodSelectCommonValue);
        selectedAllProcessCount(memberDto.mbNum)
    })

    const updateOrderList = ((payload) => {
        let data = JSON.parse(payload.body);
        selectTotalOrderList(periodSelectCommonValue);
        selectedAllProcessCount(memberDto.mbNum)
    })

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [orderListDisplayLimit, setOrderListDisplayLimit] = useState(20);
    const handleMoreOrderList = () => {
        setOrderListDisplayLimit(prev => prev + 20);
    }

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    useEffect(() => {
        const combined = [
            ...orderdtList.map((item) => ({
                type: 'orderdt',
                date: item.modiTime || item.regTime,
                mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
                ...item,
            })),
            ...payinfoList.map((item) => ({
                type: 'payinfo',
                date: item?.modiTime || item?.regTime,
                mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
                ...item,
            })),
        ];

        combined.sort((a, b) => b.mostRecentDate - a.mostRecentDate);
        // combined.sort((a, b) => moment(b.date).isAfter(moment(a.date)) ? 1 : -1);

        const filterStatus = (order) => {
            if (orderStSelectCommonValue === t(`state`)) return true;
            switch (orderStSelectCommonValue) {
                case "PS0":
                    return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
                        (order.type === 'payinfo' && order.payStatus === "PS0");
                case "PS1":
                    return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
                        (order.type === 'payinfo' && order.payStatus === "PS1");
                case "PS2":
                    return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
                        (order.type === 'payinfo' && order.payStatus === "PS2");
                case "PS3":
                    return (order.type === 'orderdt' && order.orderStatus === "OS12") ||
                        (order.type === 'payinfo' && order.payStatus === "PS3");
                case "PS4":
                    return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
                        (order.type === 'payinfo' && order.payStatus === "PS4");
                case "PS5":
                    return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
                        (order.type === 'payinfo' && order.payStatus === "PS5");
                default:
                    return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
                        (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
            }
        }

        const filterOrderType = (order) => {
            if (orderTypeSelectCommonValue === t('orderType')) {
                return true;  // 모든데이터
            }
            if (orderTypeSelectCommonValue === t('myTab1')) {
                return order.type === 'orderdt';
            }
            if (orderTypeSelectCommonValue === t('deliveryOption')) {
                return order.type === 'payinfo';
            }
            return true;
        };

        const newList = combined.filter((order) => {
            if (!filterStatus(order)) return false;
            if (!filterOrderType(order)) return false;
            if (searchQuery === "") return true;

            if (order.type === 'orderdt') {
                return (
                    (order.shipco && order.shipco.toLowerCase().includes(searchQuery)) ||
                    (order.recinfoDTO.recname && order.recinfoDTO.recname.toLowerCase().includes(searchQuery)) ||
                    (order.recinfoDTO.countryDTO && order.recinfoDTO.countryDTO.countryEngNm.toLowerCase().includes(searchQuery)) ||
                    (order.productsDTO && order.productsDTO.some((prod) => prod.name && prod.name.toLowerCase().includes(searchQuery)))
                );
            }
            if (order.type === 'payinfo') {
                return (
                    (order && convertToShipco(order.dvType, order.orderdtDTO?.shipco).toLowerCase().includes(searchQuery)) ||
                    (order.appRecDTO && order.appRecDTO.countryDTO && order.appRecDTO.countryDTO.countryEngNm.toLowerCase().includes(searchQuery)) ||
                    (order.appRecDTO && order.appRecDTO.recname && order.appRecDTO.recname.toLowerCase().includes(searchQuery)) ||
                    (order.packListDTO && order.packListDTO.productsDTO && order.packListDTO.productsDTO.some((prod) => prod.name && prod.name.toLowerCase().includes(searchQuery)))
                );
            }
        });
        setFilteredList(newList);
    }, [orderdtList, payinfoList, searchQuery, orderStSelectCommonValue, orderTypeSelectCommonValue]);

    useEffect(() => {
        if (memberDto.mbNum)
            selectedAllProcessCount(memberDto.mbNum)
    }, [memberDto])

    const [processData, setProcessData] = useState([]);
    const selectedAllProcessCount = ((mbNum) => {
        axios({
            method: 'get',
            url: '/order/selectedAllProcessCount',
            params: {
                mbNum: mbNum
            }
        })
            .then((response) => {
                setProcessData(response.data);
            })
            .catch((error) => {
                console.log("프로세스수량 조회실패 : ", error)
            })
    })

    const selectNoDateTotalOrderList = ((orderSt) => {
        axios({
            method: 'get',
            url: '/order/selectTotalOrderList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                // let sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                // sortedData = sortedData.slice(0, 10);
                setOrderdtList(response.data);
                const ProdList = response.data.map(order => {
                    const productMap = new Map();
                    order.productsDTO.forEach(product => {
                        if (!productMap.has(product.seqnum)) {
                            productMap.set(product.seqnum, product);
                        }
                    });
                    return Array.from(productMap.values());
                });
                setProductsList(ProdList);

                const payList = response.data.flatMap(order => order.payInfoDTO);
                setPayinfoList(payList);

                const recList = response.data.map(order => order.recinfoDTO);
                setRecinfoList(recList);

                orderStBtHandle(orderSt);
                setPeriodSelectCommonValue(t('all'))

            })
            .catch((error) => {
                console.log("노데이트 주문조회실패 : ", error)
            })
    })

    const [payPeriodSelectShow, setPayPeriodSelectShow] = useState(false);
    const [payPeriodSelectCommonValue, setPayPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const payPeriodButtonRef = useRef(null);
    const payPeriodDivRef = useRef(null);

    const payPeriodBtHandle = (newValue) => {
        setPayPeriodSelectShow(false);
        setPayPeriodSelectCommonValue(newValue);
    };
    const payPeriodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const payPeriodClickOutside = (event) => {
            if (
                payPeriodButtonRef.current &&
                payPeriodButtonRef.current.contains(event.target)
            ) {
                // Clicked on the duration button
                setPayPeriodSelectShow(true);
            } else if (
                payPeriodDivRef.current &&
                !payPeriodDivRef.current.contains(event.target)
            ) {
                // Clicked outside the div
                setPayPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', payPeriodClickOutside);
        return () => {
            document.removeEventListener('mousedown', payPeriodClickOutside);
        };
    }, []);

    const filterOrderSt = (status) => {

        let viewStatus;
        switch (status) {
            case t(`state`):
                viewStatus = t(`state`);
                break;
            case "OS00":
                viewStatus = t(`prodStLabel1`);
                break;
            case "OS01":
                viewStatus = t(`prodStLabel2`);
                break;
            case "OS02":
                viewStatus = t(`prodStLabel3`);
                break;
            case "OS03":
                viewStatus = t(`prodStLabel4`);
                break;
            case "OS04":
                viewStatus = t(`prodStLabel14`);
                break;
            case "OS05":
                viewStatus = t(`prodStLabel5`);
                break;
            case "OS06":
                viewStatus = t(`prodStLabel15`);
                break;
            case "OS07":
                viewStatus = t(`prodStLabel6`);
                break;
            case "OS08":
                viewStatus = t(`prodStLabel7`);
                break;
            case "PS0":
                viewStatus = t(`prodStLabel8`);
                break;
            case "PS1":
                viewStatus = t(`prodStLabel9`);
                break;
            case "PS2":
                viewStatus = t(`prodStLabel10`);
                break;
            case "PS3":
                viewStatus = t(`prodStLabel11`);
                break;
            case "PS4":
                viewStatus = t(`prodStLabel12`);
                break;
            case "PS5":
                viewStatus = t(`prodStLabel13`);
                break;
        }
        return viewStatus;
    };

    const [payList, setPayList] = useState([]);
    const payHistoryList = ((dateParam) => {

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/payHistoryList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate,
            },
        })
            .then((response) => {
                // payType이 통합결제이거나 자식이 아닌 단독결제건(상품금액/해외배송료/기타비용)만 출력
                const filteredData = response.data.filter(data => data.payType === 'PT3' || !data.childFl);
                setPayList(filteredData);
            })
            .catch(() => {
                console.log("실패")
            })
    })

    const sortedPayList = payList.sort((a, b) => b.seqNum - a.seqNum);
    const [payListDisplayLimit, setPayListDisplayLimit] = useState(20);
    const handleMorePayList = () => {
        setPayListDisplayLimit(prev => prev + 20);
    }

    const [payStSelectShow, setPayStSelectShow] = useState(false);
    const [payStSelectCommonValue, setPayStSelectCommonValue] = useState(t(`state`));
    const payStButtonRef = useRef(null);
    const payStDivRef = useRef(null);

    const payStBtHandle = (newValue) => {
        setPayStSelectShow(false);
        setPayStSelectCommonValue(newValue);
        filterPaySt(newValue);
    };

    useEffect(() => {
        payHistoryList(payPeriodSelectCommonValue);
    }, [payPeriodSelectCommonValue]);

    const payStDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const payStClickOutside = (event) => {
            if (
                payStButtonRef.current &&
                payStButtonRef.current.contains(event.target)
            ) {
                setPayStSelectShow(true);
            } else if (
                payStDivRef.current &&
                !payStDivRef.current.contains(event.target)
            ) {
                setPayStSelectShow(false);
            }
        };
        document.addEventListener('mousedown', payStClickOutside);
        return () => {
            document.removeEventListener('mousedown', payStClickOutside);
        };
    }, []);

    const filterStatus = (pay) => {
        if (payStSelectCommonValue === t(`state`)) return true;
        return pay.payStatus === payStSelectCommonValue;
    }

    const filterPaySt = (status) => {
        let viewStatus;
        switch (status) {
            case t(`state`):
                viewStatus = t(`state`)
                break;
            case "PS0":
                viewStatus = t(`prodStLabel8`)
                break;
            case "PS1":
                viewStatus = t(`prodStLabel9`)
                break;
            case "PS2":
                viewStatus = t(`prodStLabel10`)
                break;
        }
        return viewStatus;
    };

    const [dacPeriodSelectShow, setDacPeriodSelectShow] = useState(false);
    const [dacPeriodSelectCommonValue, setDacPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const dacPeriodButtonRef = useRef(null);
    const dacPeriodDivRef = useRef(null);

    const dacPeriodBtHandle = (newValue) => {
        setDacPeriodSelectShow(false);
        setDacPeriodSelectCommonValue(newValue);
        dacHistoryList(newValue);
    };
    const dacPeriodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const dacPeriodClickOutside = (event) => {
            if (
                dacPeriodButtonRef.current &&
                dacPeriodButtonRef.current.contains(event.target)
            ) {
                // Clicked on the duration button
                setDacPeriodSelectShow(true);
            } else if (
                dacPeriodDivRef.current &&
                !dacPeriodDivRef.current.contains(event.target)
            ) {
                // Clicked outside the div
                setDacPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', dacPeriodClickOutside);
        return () => {
            document.removeEventListener('mousedown', dacPeriodClickOutside);
        };
    }, []);

    const [dacList, setDacList] = useState([]);
    const dacHistoryList = ((dateParam) => {

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/dacHistoryList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate
            },
        })
            .then((response) => {
                setDacList(response.data)
                // console.log("예적쿠 리스트 : ", response.data)
            })
            .catch(() => {
                console.log("실패")
            })
    })

    useEffect(() => {
        dacHistoryList(dacPeriodSelectCommonValue);
    }, [dacPeriodSelectCommonValue]);

    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }
        return `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
    };

    const sortedDacList = dacList.sort((a, b) => b.seqNum - a.seqNum);
    const initialLimit = 10;

    const [dacDisplayLimits, setDacDisplayLimits] = useState({
        deposit: initialLimit,
        point: initialLimit,
        coupon: initialLimit,
    });

    const handleMoreDacList = (type) => {
        setDacDisplayLimits(prevLimits => ({
            ...prevLimits,
            [type]: prevLimits[type] + 10
        }));
    };

    const [selectedRows, setSelectedRows] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
    const handleCheckboxChange = (orderId) => {
        setSelectedRows(prevRows => {
            if (prevRows.includes(orderId)) {
                return prevRows.filter(row => row !== orderId);
            } else {
                return [...prevRows, orderId];
            }
        });
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(
                filteredList.map(order => {
                    if (order.type === 'orderdt') {
                        return order.seqnum;
                    } else if (order.type === 'payinfo' && (order.payType === "PT1")) {
                        return order.seqNum;
                    }
                    return null;
                }).filter(seqNum => seqNum !== null)
            );
        }
        setSelectAll(!selectAll);
    };

    const [downNoSelectSt, setDownNoSelectSt] = useState(false);
    const closeDownNoSelect = (() => {
        setDownNoSelectSt(false);
    })

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;

    const [nonSelectedShow, setNonSelectedShow] = useState(false);
    const closeNonSelectedShow = () => {
        setNonSelectedShow(false);
    }

    const invoiceDown = async () => {
        try {
            const allData = [...filteredList];
            const selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));
            console.log("다운된 데이터 : ", selectedRowData)

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');

            for (let i = 0; i < selectedRowData.length; i++) {
                const rowData = selectedRowData[i];
                const workbook = new excel.Workbook();
                // console.log('rowData:', rowData);
                workbook.created = new Date();
                workbook.modified = new Date();

                const worksheet = workbook.addWorksheet('Invoice');

                //region dataSet

                let userName = '';

                if (rowData.type === 'orderdt') {
                    userName = rowData.memberDTO.userName || '';
                } else if (rowData.type === 'payinfo') {
                    userName = rowData.orderdtDTO.memberDTO.userName || '';
                } else {
                    userName = '';
                }

                let orderNo = '';

                if (rowData.type === 'orderdt') {
                    orderNo = rowData.orderNumber || '';
                } else if (rowData.type === 'payinfo') {
                    const orderNumber = rowData.orderdtDTO?.orderNumber || '';
                    const boxNum = rowData.shipInfoDTO?.boxNum || '0';
                    orderNo = `${orderNumber}-${boxNum}`;
                } else {
                    orderNo = '';
                }

                // endregion

                // region 열너비 & 행높이

                //열너비
                worksheet.getColumn('A').width = 0.8;
                worksheet.getColumn('B').width = 13;
                worksheet.getColumn('C').width = 13;
                worksheet.getColumn('D').width = 13;
                worksheet.getColumn('E').width = 25;
                worksheet.getColumn('F').width = 23;
                worksheet.getColumn('G').width = 11;
                worksheet.getColumn('H').width = 15;
                worksheet.getColumn('I').width = 15;

                //행높이
                worksheet.getRow(1).height = 4;
                worksheet.getRow(2).height = 29;
                worksheet.getRow(3).height = 4;
                worksheet.getRow(4).height = 29;
                worksheet.getRow(5).height = 4;

                for (let row = 6; row <= 13; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(11).height = 10;
                worksheet.getRow(20).height = 4;
                worksheet.getRow(21).height = 32;
                for (let row = 22; row <= 56; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(57).height = 20;

                // endregion

                // region 엑셀내용

                const thinBorder = {style: 'thin'};

                worksheet.mergeCells('B2:I2');
                const titleCell = worksheet.getCell('B2');
                titleCell.value = 'INVOICE';
                titleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                titleCell.font = {name: 'Arial', size: 18, bold: true};
                const borderStyle = {style: 'medium'};
                worksheet.getCell('B2').border = {
                    top: borderStyle,
                    bottom: borderStyle,
                };

                worksheet.mergeCells('B4:C4');
                const lcWaybillCell = worksheet.getCell('B4');
                lcWaybillCell.value = 'L/C No. and Waybill No.';
                lcWaybillCell.alignment = {vertical: 'middle', horizontal: 'right'};
                lcWaybillCell.font = {name: 'Arial', size: 12, bold: true};

                console.log("rowData : ", rowData)

                worksheet.mergeCells('D4:E4');
                const waybillValueCell = worksheet.getCell('D4');
                if (rowData.type === 'payinfo') {
                    waybillValueCell.value = rowData.shipInfoDTO.outWayNum;
                } else {
                    waybillValueCell.value = '';
                }
                waybillValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                waybillValueCell.font = {name: 'Arial', size: 13, bold: true, italic: true};

                worksheet.mergeCells('F4:H4');
                const exportDateTitleCell = worksheet.getCell('F4');
                exportDateTitleCell.value = 'Date of Exportation.';
                exportDateTitleCell.alignment = {vertical: 'middle', horizontal: 'right'};
                exportDateTitleCell.font = {name: 'Arial', size: 12, bold: true};

                const today = new Date();
                const monthShort = today.toLocaleString('en-US', {month: 'short'}); // 예: Sep
                const day = String(today.getDate()).padStart(2, '0');                 // 예: 06
                const year = today.getFullYear();                                     // 예: 2025
                const formattedToday = `${monthShort}-${day}-${year}`;               // 예: Sep-06-2025
                const exportDateValueCell = worksheet.getCell('I4');
                exportDateValueCell.value = formattedToday;
                exportDateValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                exportDateValueCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('B6:E6');
                const shipperCell = worksheet.getCell('B6');
                shipperCell.value = 'Shipper / Exporter';
                shipperCell.alignment = {vertical: 'middle', horizontal: 'center'};
                shipperCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F6:I6');
                const consigneeCell = worksheet.getCell('F6');
                consigneeCell.value = 'Consignee';
                consigneeCell.alignment = {vertical: 'middle', horizontal: 'center'};
                consigneeCell.font = {name: 'Arial', size: 12, bold: true};

                for (let row = 7; row <= 13; row++) {
                    worksheet.mergeCells(`B${row}:E${row}`);
                }

                for (let row = 7; row <= 19; row++) {
                    worksheet.getCell(`F${row}`).border = {
                        left: thinBorder,
                    };
                }

                worksheet.getCell('E6').border = {right: thinBorder,};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}5`).border = {bottom: thinBorder};
                    worksheet.getCell(`${col}14`).border = {top: thinBorder};
                    worksheet.getCell(`${col}57`).border = {top: thinBorder, bottom: thinBorder};
                }

                const skyBlue = {argb: 'FFE5EEFF'};
                const lightGray = {argb: 'FFF0F0F0'};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}6`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let row = 14; row <= 19; row++) {
                    for (let col of ['B', 'C', 'D']) {
                        worksheet.getCell(`${col}${row}`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                    }
                }

                for (let col of ['F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}14`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}21`).fill = {type: 'pattern', pattern: 'solid', fgColor: lightGray};
                }

                // region 발송인

                worksheet.getCell('B7').value = 'IMEUNWOO(individual)';
                worksheet.getCell('B7').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B7').font = {name: 'Arial', size: 11};

                worksheet.getCell('B8').value = '32-15, Yeongok-gil 42beon-gil, Gonjiam-eup,';
                worksheet.getCell('B8').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B8').font = {name: 'Arial', size: 11};

                worksheet.getCell('B9').value = 'Gwangji-si, Gyeonggi-do (zipcode 12722)';
                worksheet.getCell('B9').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B9').font = {name: 'Arial', size: 11};

                worksheet.getCell('B10').value = 'Tel: 82-10-3338-9354';
                worksheet.getCell('B10').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B10').font = {name: 'Arial', size: 11};

                worksheet.getCell('B12').value = '(empty)';
                worksheet.getCell('B12').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B12').font = {name: 'Arial', size: 11};

                worksheet.getCell('B13').value = '(empty)';
                worksheet.getCell('B13').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B13').font = {name: 'Arial', size: 11};

                // endregion

                // region 수취인

                const receiver = rowData.type === 'payinfo'
                    ? rowData.appRecDTO
                    : rowData.recinfoDTO;

                const fullAddress =
                    (receiver?.address1 || '') +
                    (receiver?.address2 || '') +
                    (receiver?.address3 || '');

                const cityZipcode =
                    (receiver?.city || '') +
                    ' (zipcode ' + (receiver?.zipcode || '') + ')';

                worksheet.mergeCells('F7:I13');
                const mergedCell = worksheet.getCell('F7');

                mergedCell.value =
                    (receiver?.recname || '') + '\n' +
                    fullAddress + '\n' +
                    cityZipcode + '\n\n' +
                    'Tel: ' + (receiver?.telnum || '');

                mergedCell.alignment = {vertical: 'top', horizontal: 'left', wrapText: true};
                mergedCell.font = {name: 'Arial', size: 11};

                //수취인과 다를경우 직접입력
                worksheet.mergeCells('F15:I19');
                const mergedBuyerCell = worksheet.getCell('F15');
                mergedBuyerCell.value = '';
                mergedBuyerCell.alignment = {vertical: 'middle', horizontal: 'left'};
                mergedBuyerCell.font = {name: 'Arial', size: 11};

                // endregion

                // region 기타정보

                worksheet.mergeCells('B14:D15');
                const countryExportCell = worksheet.getCell('B14');
                countryExportCell.value = 'Country of Export';
                countryExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                countryExportCell.font = {name: 'Arial', size: 11, bold: true};
                countryExportCell.border = {top: thinBorder};

                worksheet.mergeCells('F14:I14');
                const buyerCell = worksheet.getCell('F14');
                buyerCell.value = 'Buyer (if other than consignee)';
                buyerCell.alignment = {vertical: 'middle', horizontal: 'center'};
                buyerCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('B16:D17');
                const reasonExportCell = worksheet.getCell('B16');
                reasonExportCell.value = 'Reason for Export';
                reasonExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                reasonExportCell.font = {name: 'Arial', size: 11, bold: true};
                reasonExportCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('E14:E15');
                const koreaCell = worksheet.getCell('E14');
                koreaCell.value = 'Republic of Korea [KR]';
                koreaCell.alignment = {vertical: 'middle', horizontal: 'center'};
                koreaCell.font = {name: 'Arial', size: 11};
                koreaCell.border = {bottom: thinBorder};
                koreaCell.border = {top: thinBorder};

                worksheet.mergeCells('E16:E17');
                const giftCell = worksheet.getCell('E16');
                giftCell.value = 'e.g.personal gift';
                giftCell.alignment = {vertical: 'middle', horizontal: 'center'};
                giftCell.font = {name: 'Arial', size: 11};
                giftCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('B18:D19');
                const destinationTitleCell = worksheet.getCell('B18');
                destinationTitleCell.value = 'Country of Ultimate Destination';
                destinationTitleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationTitleCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('E18:E19');
                const destinationCountryCell = worksheet.getCell('E18');
                let destinationCountry = '';
                if (rowData.type === 'orderdt') {
                    destinationCountry =
                        (rowData.recinfoDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.recinfoDTO.countryDTO.countryCode || '') + ']';
                } else if (rowData.type === 'payinfo') {
                    destinationCountry =
                        (rowData.appRecDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.appRecDTO.countryDTO.countryCode || '') + ']';
                }
                destinationCountryCell.value = destinationCountry;
                destinationCountryCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationCountryCell.font = {name: 'Arial', size: 10};

                // endregion

                worksheet.mergeCells('B20:I20');
                const GbnCell = worksheet.getCell('B20');
                GbnCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.getCell('B21').value = 'Country of Origin';
                worksheet.getCell('B21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('B21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C21').value = 'Pkgs / Type';
                worksheet.getCell('C21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('D21:F21');
                worksheet.getCell('D21').value = 'Description of Goods';
                worksheet.getCell('D21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('D21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('G21').value = 'Qty / Unit';
                worksheet.getCell('G21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('G21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('H21').value = 'Qty / Unit Price(USD)';
                worksheet.getCell('H21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('H21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('I21').value = 'Total Amount(USD)';
                worksheet.getCell('I21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('I21').font = {name: 'Arial', size: 11, bold: true};

                for (let row = 22; row <= 56; row++) {
                    worksheet.mergeCells(`D${row}:F${row}`);
                }

                for (let row = 21; row <= 56; row++) {
                    for (let col of ['B', 'C', 'D', 'G', 'H']) {
                        worksheet.getCell(`${col}${row}`).border = {
                            right: thinBorder,
                        };
                    }
                }

                worksheet.getCell('B22').value = 'KR';
                worksheet.getCell('B22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('B22').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C22').value = '1 / cartons';
                worksheet.getCell('C22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C22').font = {name: 'Arial', size: 11, bold: true};

                const startRow = 22;
                const KRW_TO_USD = 1400;
                let products = [];

                if (rowData.type === 'orderdt') {
                    products = rowData.productsDTO || [];
                } else if (rowData.type === 'payinfo') {
                    products = (rowData.packListDTO && rowData.packListDTO.productsDTO) || [];
                }

                products.forEach((product, index) => {
                    const row = startRow + index;

                    const quantity = product.quantity || 0;
                    const priceKRW = product.price || 0;
                    const totalKRW = quantity * priceKRW;

                    const priceUSD = priceKRW / KRW_TO_USD;
                    const totalUSD = totalKRW / KRW_TO_USD;

                    if (row > 56) return;

                    worksheet.getCell(`D${row}`).value = product.name || '';
                    worksheet.getCell(`D${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`D${row}`).font = {name: 'Arial', size: 11};

                    worksheet.getCell(`G${row}`).value = (product.quantity || 0).toLocaleString();
                    worksheet.getCell(`G${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`G${row}`).font = {name: 'Arial', size: 11};

                    worksheet.getCell(`H${row}`).value = priceUSD;
                    worksheet.getCell(`H${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`H${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`H${row}`).numFmt = '"$"#,##0.00';

                    worksheet.getCell(`I${row}`).value = totalUSD;
                    worksheet.getCell(`I${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`I${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`I${row}`).numFmt = '"$"#,##0.00';
                });

                const totalQty = products.reduce((sum, product) => {
                    return sum + (product.quantity || 0);
                }, 0);

                worksheet.getCell('G57').value = `${totalQty} EA`;
                worksheet.getCell('G57').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('G57').font = {name: 'Arial', size: 12, bold: true};

                worksheet.getCell('I57').value = {formula: 'SUM(I22:I56)'};
                worksheet.getCell('I57').alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                worksheet.getCell('I57').font = {name: 'Arial', size: 12, bold: true};
                worksheet.getCell('I57').numFmt = '"$"#,##0.00';

                const totalCell = worksheet.getCell('F57');
                totalCell.value = 'Total';
                totalCell.alignment = {vertical: 'middle', horizontal: 'right'};
                totalCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F60:F61');

                const signedByCell = worksheet.getCell('F60');
                signedByCell.value = 'Signed By.';
                signedByCell.alignment = {vertical: 'bottom', horizontal: 'right'};
                signedByCell.font = {name: 'Arial', size: 11};
                // ✅ I61
                const signatureNameCell = worksheet.getCell('I61');
                signatureNameCell.value = 'IMEUNWOO';
                signatureNameCell.alignment = {vertical: 'bottom', horizontal: 'center'};
                signatureNameCell.font = {name: 'Arial', size: 12, bold: true};

                for (let col of ['G', 'H', 'I']) {
                    worksheet.getCell(`${col}61`).border = {
                        bottom: thinBorder,
                    };
                }

                // endregion

                // region 다운로드

                worksheet.pageSetup.printArea = 'A1:I61';

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `[${userName}님]인보이스_${orderNo}_${DateViewValue}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);

                // endregion
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getProdStLabel = (prodSt) => {
        const prodStStyles = {
            IS00: "입고대기", IS01: "결제대기(상품)", IS02: "결제중(상품)",
            IS03: "결제완료(상품)", IS04: "구매완료", IS05: "센터도착",
            IS06: "패킹중", IS07: "결제대기(배송)", IS08: "결제중(배송)",
            IS09: "결제완료(배송)", IS10: "출고완료", IS11: "반송중",
            IS12: "신청취소", IS13: "구매중", IS14: "입고중"
        };
        return prodStStyles[prodSt] || "";
    };

    // 주문내역
    const excelDown = () => {
        try {
            const allData = [...filteredList];
            const selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            // region 주문상태(OS) & 상품상태(IS) 정의

            function interpretOrderStatus(status) {
                const statusMap = {
                    'OS00': '입고대기',
                    'OS01': '결제대기(상품)',
                    'OS02': '결제중(상품)',
                    'OS03': '결제대기(상품)',
                    'OS04': '구매중',
                    'OS05': '구매완료',
                    'OS06': '입고중',
                    'OS07': '센터도착',
                    'OS08': '패킹중',
                    'OS09': '결제대기(배송)',
                    'OS10': '결제중(배송)',
                    'OS11': '결제완료(배송)',
                    'OS12': '출고완료',
                    'OS13': '반송중',
                    'OS14': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretPayStatus(status) {
                const statusMap = {
                    'PS0': '결제대기',
                    'PS1': '결제중',
                    'PS2': '결제완료',
                    'PS3': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdType(status) {
                const statusMap = {
                    'P00': '장바구니',
                    'P01': '구매대행',
                    'P02': '오프라인',
                    'P03': '이체대행',
                    'P04': '국내배송',
                    'P05': '배송대행',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdStatus(status) {
                const statusMap = {
                    'IS00': '입고대기',
                    'IS01': '결제대기(P)',
                    'IS02': '결제중(P)',
                    'IS03': '결제완료(P)',
                    'IS04': '구매완료',
                    'IS05': '센터도착',
                    'IS06': '패킹중',
                    'IS07': '결제대기(D)',
                    'IS08': '결제중(D)',
                    'IS09': '결제완료(D)',
                    'IS10': '출고완료',
                    'IS11': '반송중',
                    'IS12': '신청취소',
                    'IS13': '구매중',
                    'IS14': '입고중',
                };
                return statusMap[status] || 'N/A';
            }

            // endregion

            function getSafeValue(obj, key, defaultValue = '') {
                return obj && obj[key] !== undefined ? obj[key] : defaultValue;
            }

            function getSafeArray(obj, key) {
                return obj && Array.isArray(obj[key]) ? obj[key] : [];
            }

            // region 해당하는 열에 각 데이터 지정하여 전달

            function mapDataToExcelRows(item) {
                const productsDTO = item.type === 'orderdt'
                    ? getSafeArray(item, 'productsDTO')
                    : getSafeArray(item.packListDTO, 'productsDTO');

                // 수수료계열
                let ttEtcFee = 0;
                let etcFeeNm = '';
                let repackFee = 0;
                let agencyFee = 0;
                let removeFee = 0;
                let deliveryFee = 0;
                let comprFee = 0;

                // 할인
                let appSalePrice = 0;

                // 비용계열
                let ttEtcPrice = 0;
                let etcPriceNm = '';
                let returnFee = 0;
                let courierPay = 0;

                if (item.type === 'orderdt') {
                    const pt2PayInfo = (Array.isArray(item.payInfoDTO) ? item.payInfoDTO : [item.payInfoDTO])
                        .find(info => info?.payType === 'PT2');

                    ttEtcFee = pt2PayInfo?.ttEtcFee || 0; // 총기타수수료
                    etcFeeNm = pt2PayInfo?.etcFeeNm || ''; // 기타수수료명
                    repackFee = pt2PayInfo?.repackFee || 0; // 재포장수수료
                    agencyFee = pt2PayInfo?.agencyFee || 0; // 대행수수료
                    removeFee = pt2PayInfo?.removeFee || 0; // 제거작업 수수료
                    deliveryFee = pt2PayInfo?.deliveryFee || 0; // 배송대행수수료
                    comprFee = pt2PayInfo?.comprFee || 0; // 압축팩수수료

                    ttEtcPrice = pt2PayInfo?.ttEtcPrice || 0; // 총기타비용
                    etcPriceNm = pt2PayInfo?.etcPriceNm || ''; // 기타비용명
                    returnFee = pt2PayInfo?.returnFee || 0; // 국내반송료
                    courierPay = pt2PayInfo?.courierPay || 0; // 착불비
                }

                return productsDTO.map(product => ({
                    '여백': '',
                    '주문번호': item.type === 'orderdt' ? getSafeValue(item, 'orderNumber', '')
                        : `${getSafeValue(item.orderdtDTO, 'orderNumber', '')}-${getSafeValue(item.shipInfoDTO, 'boxNum', '')}`,
                    '주문유형': item.type === 'orderdt' ? '주문서' : '배송료',
                    '사서함번호': item.type === 'orderdt' ? 'BT' + getSafeValue(item.memberDTO, 'mbNum', '') : 'BT' + getSafeValue(item.orderdtDTO.memberDTO, 'mbNum', ''),
                    '고객명': item.type === 'orderdt' ? getSafeValue(item.memberDTO, 'userName', '') : getSafeValue(item.orderdtDTO.memberDTO, 'userName', ''),
                    '수취인명': getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'recname', ''),
                    '국가': `${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryNm || ''}[${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryCode || ''}]`,
                    '주문상태': item.type === 'orderdt' ? interpretOrderStatus(item.orderStatus) : interpretPayStatus(item.payStatus),
                    '서비스구분': interpretProdType(product.prodTy),
                    '개별상태': interpretProdStatus(product.prodSt),
                    '상품명': product.name,
                    '상품옵션': product.option,
                    '상품수량': product.quantity || 0,
                    '금액': product.price || 0,
                    '몰배송비': product.mallShipPrice || 0,
                    '상품수수료': product.fee || 0,
                    'URL': product.url || '',
                    '배송사': item.type === 'orderdt' ? getSafeValue(item, 'shipco', '') : (convertToShipco(item.dvType) || ''),
                    '운송장번호': item.type === 'orderdt' ? '' : getSafeValue(item.shipInfoDTO, 'outWayNum', ''),

                    // 조건 1 적용 (서로 겹치지 않게 처리 & 명칭 매핑 통일)
                    '국내반송료': item.type === 'orderdt' ? returnFee : 0,
                    '착불비': item.type === 'orderdt' ? courierPay : 0,
                    '기타비용': item.type === 'orderdt' ? ttEtcPrice : 0,
                    '기타비용내용': item.type === 'orderdt' ? etcPriceNm : '',
                    '재포장수수료': item.type === 'orderdt' ? repackFee : 0,
                    '대행수수료': item.type === 'orderdt' ? agencyFee : 0,
                    '제거작업수수료': item.type === 'orderdt' ? removeFee : 0,
                    '압축팩수수료': item.type === 'orderdt' ? comprFee : 0,
                    '배송대행수수료': item.type === 'orderdt' ? deliveryFee : 0,
                    '기타수수료': item.type === 'orderdt' ? ttEtcFee : 0,
                    '기타수수료내용': item.type === 'orderdt' ? etcFeeNm : '',

                    // 조건 2 적용 (앱할인은 음수처리)
                    '앱할인': item.type !== 'orderdt' ? (item.appSalePrice ? -Math.abs(item.appSalePrice) : 0) : 0,

                    'FedEx': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexPrice', 0) : 0,
                    'FedEx-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexEcoPrice', 0) : 0,
                    'UPS': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsPrice', 0) : 0,
                    'UPS-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsEcoPrice', 0) : 0,
                    'EMS': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrice', 0) : 0,
                    'EMSP': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrePrice', 0) : 0,
                    'Kpack': item.type !== 'orderdt' ? getSafeValue(item, 'ttKPackPrice', 0) : 0,
                    'Small-Packet': item.type !== 'orderdt' ? getSafeValue(item, 'ttAirSPrice', 0) : 0,
                    'Sea': item.type !== 'orderdt' ? getSafeValue(item, 'ttSeaPrice', 0) : 0,

                    '출고일시': item.type === 'orderdt' ? getSafeValue(item, 'shipTime', '') : item.type === 'payinfo' && (item.shipTime !== null && item.shipTime !== '') ?
                        getSafeValue(item, 'shipTime', '') : getSafeValue(item.shipInfoDTO, 'outRegTime', ''),
                }));
            }

            // endregion

            // region 헤더(1행)의 값과 스타일 지정

            const sheetConfigs = {
                'Btorage Order': {
                    name: 'Btorage Order',
                    columns: [
                        {header: '', key: '여백', width: 0.5},
                        {header: '주문번호', key: '주문번호', width: 25, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문유형', key: '주문유형', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '사서함번호', key: '사서함번호', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '고객명', key: '고객명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '수취인명', key: '수취인명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '국가', key: '국가', width: 18, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문상태', key: '주문상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '서비스구분', key: '서비스구분', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '개별상태', key: '개별상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품명', key: '상품명', width: 30},
                        {header: '상품옵션', key: '상품옵션', width: 30},
                        {header: '상품수량', key: '상품수량', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '금액', key: '금액', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '몰배송비', key: '몰배송비', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품수수료', key: '상품수수료', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: 'URL', key: 'URL', width: 10},
                        {header: '배송사', key: '배송사', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '운송장번호', key: '운송장번호', width: 20, style: {alignment: {horizontal: 'center'}}},

                        // 추가된 컬럼들 반영
                        {header: '국내반송료', key: '국내반송료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '착불비', key: '착불비', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용', key: '기타비용', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용내용', key: '기타비용내용', width: 40},
                        {header: '재포장수수료', key: '재포장수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '대행수수료', key: '대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '제거작업수수료', key: '제거작업수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '압축팩수수료', key: '압축팩수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '배송대행수수료', key: '배송대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료', key: '기타수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료내용', key: '기타수수료내용', width: 40},

                        {header: '앱할인', key: '앱할인', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx', key: 'FedEx', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx-E', key: 'FedEx-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS', key: 'UPS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS-E', key: 'UPS-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMS', key: 'EMS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMSP', key: 'EMSP', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'Kpack', key: 'Kpack', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {
                            header: 'Small-Packet',
                            key: 'Small-Packet',
                            width: 13,
                            style: {alignment: {horizontal: 'center'}}
                        },
                        {header: 'Sea', key: 'Sea', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '출고일시', key: '출고일시', width: 20, style: {alignment: {horizontal: 'center'}}},
                    ],
                }
            };

            // endregion

            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({includeEmpty: true}, (cell) => {
                    cell.border = border;
                });
            };

            const createSheet = (name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                return sheet;
            };

            // region 주문서와 배송료를 한눈에 구분하기 위해 색상 칠

            const addRowsToSheet = (sheet, rows, border) => {
                rows.forEach((item) => {
                    const row = sheet.addRow(item);

                    //주문번호 열
                    const orderNumberCell = row.getCell('주문번호');
                    const orderNumberValue = orderNumberCell.value ? orderNumberCell.value.toString() : '';
                    orderNumberCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderNumberValue.includes('-') ? 'edf5fa' : 'fffae8'},
                    };

                    //주문유형 열
                    const orderTypeCell = row.getCell('주문유형');
                    orderTypeCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderTypeCell.value === '주문서' ? 'fffae8' : 'edf5fa'},
                    };

                    // URL 열 하위 값들 하이퍼링크 적용
                    const urlCell = row.getCell('URL');
                    if (
                        urlCell.value &&
                        typeof urlCell.value === 'string' &&
                        (urlCell.value.startsWith('http://') || urlCell.value.startsWith('https://'))
                    ) {
                        urlCell.value = {text: urlCell.value, hyperlink: urlCell.value};
                        urlCell.font = {color: {argb: 'FF0000FF'}, underline: true, name: '맑은 고딕', size: 10};
                    }

                    row.eachCell({includeEmpty: true}, (cell) => {
                        // URL 셀은 별도 폰트 설정을 유지
                        if(cell._column.key !== 'URL'){
                            cell.font = {name: '맑은 고딕', size: 10};
                        }
                    });
                    applyBordersToRow(row, border);
                });
            };

            // endregion

            // region 병합할 행열 지정 (배열을 받아 처리하는 형태로 리팩토링)

            const mergeCellsByCondition = (sheet, columnsToMerge) => {
                let startRow = 3; // 데이터 시작 행 (1행: 헤더, 2행: 합계)
                while (startRow <= sheet.rowCount) {
                    const matchValues = columnsToMerge.map(col => sheet.getCell(`${col}${startRow}`).value);
                    let endRow = startRow;

                    while (endRow + 1 <= sheet.rowCount) {
                        const nextValues = columnsToMerge.map(col => sheet.getCell(`${col}${endRow + 1}`).value);
                        const isMatch = matchValues.every((val, index) => val === nextValues[index]);

                        if (isMatch) {
                            endRow++;
                        } else {
                            break;
                        }
                    }

                    if (endRow > startRow) {
                        columnsToMerge.forEach(col => {
                            sheet.mergeCells(`${col}${startRow}:${col}${endRow}`);
                            const mergedCell = sheet.getCell(`${col}${startRow}`);
                            mergedCell.alignment = { vertical: 'middle', horizontal: 'center' };
                        });
                    }

                    startRow = endRow + 1; // 다음 그룹으로 이동
                }
            };

            // endregion

            const transformedRows = selectedRowData.flatMap(mapDataToExcelRows);

            if (sheetConfigs) {
                const sheet = createSheet(sheetConfigs['Btorage Order'].name, sheetConfigs['Btorage Order'].columns);

                //행 고정
                sheet.views = [
                    {state: 'frozen', xSplit: 5, ySplit: 2, activeCell: 'F3'}
                ];

                // region 주문유형 - 배송료 헤더를 색칠(주문서와 배송료 구분하기 좋게)

                const targetHeaders = [
                    '운송장번호',
                    '국내반송료',
                    '착불비',
                    '기타비용',
                    '기타비용내용',
                    '재포장수수료',
                    '대행수수료',
                    '제거작업수수료',
                    '압축팩수수료',
                    '배송대행수수료',
                    '기타수수료',
                    '기타수수료내용',
                    '앱할인',
                    'FedEx',
                    'FedEx-E',
                    'UPS',
                    'UPS-E',
                    'EMS',
                    'EMSP',
                    'Kpack',
                    'Small-Packet',
                    'Sea',
                    '출고일시'
                ];

                const headerRow = sheet.getRow(1);
                headerRow.eachCell((cell) => {
                    cell.alignment = {horizontal: 'center'};
                    cell.font = {bold: true, name: '맑은 고딕', size: 11};

                    if (targetHeaders.includes(cell.value)) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'edf5fa'}
                        };
                    }
                });

                // endregion

                const columnMap = {};
                sheet.columns.forEach((col) => {
                    if (col.key && col.letter) {
                        columnMap[col.key] = col.letter;
                    }
                });

                // 데이터 행 범위 설정 (데이터는 3행부터 시작)
                const dataStartRow = 3;
                const dataEndRow = dataStartRow + transformedRows.length - 1;

                // region 지정된 열 하위 행의 값들 합산

                const sumKeys = ['상품수량', '금액', '몰배송비', '상품수수료', '국내반송료', '착불비', '기타비용', '재포장수수료', '대행수수료', '제거작업수수료', '압축팩수수료', '배송대행수수료', '기타수수료', '앱할인', 'FedEx', 'FedEx-E', 'UPS', 'UPS-E', 'EMS', 'EMSP', 'Kpack', 'Small-Packet', 'Sea'];

                const summaryRow = {};
                sheetConfigs['Btorage Order'].columns.forEach(col => {
                    summaryRow[col.key] = '';
                });

                // 첫열에 텍스트 표시
                summaryRow['주문번호'] = '합계';

                // 합계 대상 열에는 수식 지정
                sumKeys.forEach((key) => {
                    const colLetter = columnMap[key];
                    if (colLetter) {
                        summaryRow[key] = {formula: `SUM(${colLetter}${dataStartRow}:${colLetter}${dataEndRow})`};
                    }
                });

                sheet.spliceRows(2, 0, summaryRow);

                const summaryExcelRow = sheet.getRow(2);
                for (let col = 2; col <= 40; col++) { // 총 40개 컬럼까지 스타일 적용
                    const cell = summaryExcelRow.getCell(col);
                    cell.alignment = {horizontal: 'right'};
                    cell.font = {name: '맑은 고딕', size: 10, bold: true, color: {argb: 'FFFF0000'}};
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: 'f1f1f1'}
                    };

                    // 숫자인 경우 통화단위 표시
                    if (
                        (typeof cell.value === 'number') ||
                        (cell.value && typeof cell.value === 'object' && cell.value.formula)
                    ) {
                        cell.numFmt = '#,##0';
                    }
                }

                addRowsToSheet(sheet, transformedRows, borderHeaderStyle);

                sheet.eachRow({includeEmpty: true}, (row) => {
                    for (let col = 2; col <= 5; col++) { //B~E열에 해당하는 값들 Bold
                        const cell = row.getCell(col);
                        cell.font = {...(cell.font || {}), bold: true};
                    }
                });

                // region 병합할 열 전달 (리팩토링 된 함수 사용)

                mergeCellsByCondition(sheet, [
                    'B', 'C', 'D', 'E', 'F', 'G', 'H', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
                    'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN'
                ]);

                // endregion
            }

            const fileName = `[Btorage]Order_List_${DateViewValue}.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });

        } catch (error) {
            console.error(error);
        }
    }

    // 출고내역
    const excelOrderDown = async () => {
        try {
            const allData = [...filteredList];
            // 체크된 데이터 필터링
            let selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));

            // type이 'payinfo'인 데이터 제외 (orderdt만 다운로드)
            selectedRowData = selectedRowData.filter(item => item.type !== 'payinfo');

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            const worksheet = workbook.addWorksheet('Order History');

            // 1. 헤더 설정 (A ~ K열)
            worksheet.columns = [
                {header: 'OrderNumber', key: 'colA', width: 20},
                {header: 'Name', key: 'colB', width: 15},
                {header: 'Tell', key: 'colC', width: 15},
                {header: 'Address', key: 'colD', width: 45},
                {header: 'Domestic Delivery Company', key: 'colE', width: 25},
                {header: 'Domestic Tracking Number', key: 'colF', width: 25},
                {header: 'Product Name', key: 'colG', width: 30},
                {header: 'ProdSt', key: 'colH', width: 15},
                {header: 'Overseas Tracking Number', key: 'colI', width: 25}, // [New Logic Apply]
                {header: 'Order Form Payment Amount', key: 'colJ', width: 25},
                {header: 'Shipping Fee Payment Amount', key: 'colK', width: 25},
            ];

            // 2. 데이터 루프 및 가공
            selectedRowData.forEach((data) => {

                // --- J열 Total Amount 계산 ---
                let orderFormPaymentAmount = 0;

                // productsDTO 합산
                const prodSum = data.productsDTO?.reduce((sum, item) => {
                    const isValidSt = item.prodSt !== "IS01" && item.prodSt !== "IS02" && item.prodSt !== "IS12";
                    return (isValidSt && item.price > 0) ? sum + item.price + item.mallShipPrice + item.fee : sum;
                }, 0) || 0;

                // payInfoDTO 합산
                const payInfoSum = data.payInfoDTO?.reduce((sum, item) => {
                    const isValidStatus = item.payStatus !== "PS0" && item.payStatus !== "PS1";
                    const isValidClass = item.payClass === '1';
                    return (isValidStatus && isValidClass && item.ttProdExpense > 0) ? sum + item.ttProdExpense : sum;
                }, 0) || 0;

                orderFormPaymentAmount = prodSum + payInfoSum;


                // --- K열 Shipping Fee & I열 Overseas Tracking 계산 ---
                let shippingFeePaymentAmount = 0;
                let overseasTracking = null; // 초기값 null

                // payInfoDTO를 순회하며 조건 체크
                if (data.payInfoDTO && Array.isArray(data.payInfoDTO)) {
                    data.payInfoDTO.forEach(item => {
                        // 조건: payType이 PT1이고, payStatus가 PS2 혹은 PS3
                        if (item.payType === 'PT1' && (item.payStatus === 'PS2' || item.payStatus === 'PS3')) {
                            // K열 값 누적
                            shippingFeePaymentAmount += (item.ttShipExpense || 0);

                            // [조건 변경 반영] I열 값 추출: 해당 조건 데이터의 shipInfoDTO.outWayNum
                            if (item.shipInfoDTO && item.shipInfoDTO.outWayNum) {
                                overseasTracking = item.shipInfoDTO.outWayNum;
                            }
                        }
                    });
                }

                // --- 1 Order -> N Rows (productsDTO 기준) ---
                const products = data.productsDTO && data.productsDTO.length > 0 ? data.productsDTO : [{}];

                products.forEach((prod) => {
                    // recinfoDTO (소문자 i) 사용
                    const addressFull = data.recinfoDTO
                        ? `${data.recinfoDTO.address1 || ''} ${data.recinfoDTO.address2 || ''} ${data.recinfoDTO.address3 || ''} ${data.recinfoDTO.city || ''}`.trim()
                        : '';

                    const rowValues = {
                        colA: data.orderNumber,
                        colB: data.memberDTO?.userName,
                        colC: data.recinfoDTO?.telnum,
                        colD: addressFull,
                        colE: prod.domShipco || null,
                        colF: prod.inWaynum || null,
                        colG: prod.name,
                        colH: getProdStLabel(prod.prodSt),
                        colI: overseasTracking,         // 계산된 Overseas Tracking Number
                        colJ: orderFormPaymentAmount,
                        colK: shippingFeePaymentAmount
                    };

                    worksheet.addRow(rowValues);
                });
            });

            // 3. 스타일링 적용
            const headerRow = worksheet.getRow(1);
            headerRow.height = 30;
            headerRow.eachCell((cell) => {
                cell.font = {
                    name: 'Arial',
                    size: 11,
                    bold: true,
                    color: {argb: 'FFFFFFFF'} // 흰색 폰트
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    // 헤더 배경색: 주황색 (FFBE48)
                    fgColor: {argb: 'FFFFBE48'}
                };
                cell.alignment = {vertical: 'middle', horizontal: 'center'};
                cell.border = {
                    top: {style: 'thin'},
                    left: {style: 'thin'},
                    bottom: {style: 'thin'},
                    right: {style: 'thin'}
                };
            });

            // 데이터 행 스타일 (모두 가운데 정렬)
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell, colNumber) => {
                        cell.font = {name: 'Arial', size: 10};

                        // 모든 데이터 정중앙 배치
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            wrapText: true
                        };

                        cell.border = {
                            top: {style: 'thin', color: {argb: 'FFD9D9D9'}},
                            left: {style: 'thin', color: {argb: 'FFD9D9D9'}},
                            bottom: {style: 'thin', color: {argb: 'FFD9D9D9'}},
                            right: {style: 'thin', color: {argb: 'FFD9D9D9'}}
                        };

                        // 금액 컬럼(J=10, K=11) 숫자 콤마 포맷 적용
                        if (colNumber === 10 || colNumber === 11) {
                            cell.numFmt = '#,##0';
                        }
                    });
                }
            });

            // 4. 파일 다운로드 (file-saver 없이 순수 JS 구현)
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `[Btorage]Shipment_List_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("주문서 엑셀내역 다운로드 실패 : ", error);
        }
    };

    const [guidePopupOrderSt, setGuidePopupOrderSt] = useState({});
    const openGuidePopupOrder = (index) => {
        setGuidePopupOrderSt(prevStates => ({...prevStates, [index]: true}));
    }
    const closeGuidePopupOrder = (index) => {
        setGuidePopupOrderSt(prevStates => ({...prevStates, [index]: false}));
    }

    const [guidePopupPaySt, setGuidePopupPaySt] = useState({});
    const openGuidePopupPay = ((index) => {
        setGuidePopupPaySt(prevStates => ({...prevStates, [index]: true}));
    })
    const closeGuidePopupPay = ((index) => {
        setGuidePopupPaySt(prevStates => ({...prevStates, [index]: false}));
    })

    const [integPayDetailPopupSt, setIntegPayDetailPopupSt] = useState(false);
    const [integPaySeqnum, setIntegPaySeqnum] = useState(null);
    const integPayDetail = ((seqnum) => {
        setIntegPaySeqnum(seqnum);
        setIntegPayDetailPopupSt(true)
    })
    const integDetailPopupClose = (() => {
        setIntegPayDetailPopupSt(false);
    })
    useEffect(() => {
        if (integPaySeqnum !== null) {
            setIntegPayDetailPopupSt(true);
        }
    }, [integPaySeqnum]);


    // 국제배송조회 팝업상태
    const [unTrackNumSt, setUnTrackNumSt] = useState(null);
    const selectOsTrackNum = ((shipco, trackNum) => {
        if (!trackNum) {
            setUnTrackNumSt(true);
            return;
        }
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 400;
        const height = 600;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (shipco === "FedEx" || shipco === "FedEx-E") {
            const url = `https://www.fedex.com/fedextrack/?trknbr=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "UPS" || shipco === "UPS-E") {
            const url = `https://www.ups.com/track?loc=ko_KR&trackNums=${trackNum}&requester=ST/trackdetails`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "DHL") {
            const url = `https://www.dhl.com/kr-ko/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "EMS" || shipco === "SEA" || shipco === "EMSP" || shipco === "K-Packet" || shipco === "Small-Packet") {
            const url = `https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?POST_CODE=${trackNum}&displayHeader=N`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        }
    })

    const closeUnTrackNumSt = (() => {
        setUnTrackNumSt(false);
    });

    // 국내배송조회 팝업상태
    const selectDsTrackNum = ((selectedDomestic, dsTrackNum) => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 400;
        const height = 600;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (selectedDomestic === "CJ대한통운" || selectedDomestic === "CJ 대한통운") {
            const url = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "로젠택배") {
            const url = `https://www.ilogen.com/web/personal/trace/${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "우체국") {
            const url = `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${dsTrackNum}&displayHeader=N`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "한진택배") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "롯데택배") {
            const url = `https://www.lotteglogis.com/open/tracking?invno=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "경동택배") {
            const url = `https://kdexp.com/newDeliverySearch.kd?barcode=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "국내배송") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        }
    })

    const orderStPrint = (orderSt) => {
        const orderStStyles = {
            OS00: {color: "#98B0D4", label: t(`prodStLabel1`)},
            OS01: {color: "#98B0D4", label: t(`prodStLabel2`)},
            OS02: {color: "#98B0D4", label: t(`prodStLabel3`)},
            OS03: {color: "#FFB378", label: t(`prodStLabel4`)},
            OS04: {color: "#98B0D4", label: t(`prodStLabel14`)},
            OS05: {color: "#EB939D", label: t(`prodStLabel5`)},
            OS06: {color: "#98B0D4", label: t(`prodStLabel15`)},
            OS07: {color: "#6EDA60", label: t(`prodStLabel6`)},
            OS08: {color: "#98B0D4", label: t(`prodStLabel7`)},
            OS09: {color: "#98B0D4", label: t(`prodStLabel8`)},
            OS10: {color: "#98B0D4", label: t(`prodStLabel9`)},
            OS11: {color: "#FFB378", label: t(`prodStLabel10`)},
            OS12: {color: "#979696", label: t(`prodStLabel11`)},
            OS13: {color: "#FF8F62", label: t(`prodStLabel12`)},
            OS14: {color: "#FF8F62", label: t(`prodStLabel13`)},
        };

        const style = orderStStyles[orderSt] || {color: "black", label: null};
        return <p style={{margin: "0", color: style.color}}>{style.label}</p>;
    };

    const selectedTotalPricePrint = (pay) => {
        if (!pay) return;

        let prodTotal = 0;
        let shipTotal = 0;
        let etcTotal = 0;
        let integTotal = 0;

        // 상품금액 총합 계산
        if (pay.payType === "PT0") {
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttProdExpense = pay.ttProdExpense || 0;
            prodTotal += ttEtcFee + ttProdExpense;
            return prodTotal;

            // 해외배송비 총합 계산
        } else if (pay.payType === "PT1") {
            const prices = [
                pay.ttFedexPrice, pay.ttFedexEcoPrice, pay.ttDhlPrice, pay.ttEmsPrice,
                pay.ttEmsPrePrice, pay.ttUpsPrice, pay.ttUpsEcoPrice, pay.ttKPackPrice,
                pay.ttAirSPrice, pay.ttSeaPrice, pay.ttDomPrice
            ];
            const validPrice = prices.find(price => price > 0) || 0;
            shipTotal += validPrice;
            return shipTotal;

            // 기타비용 총합 계산
        } else if (pay.payType === "PT2") {
            const courierPay = pay.courierPay || 0;
            const returnFee = pay.returnFee || 0;
            const deliveryFee = pay.deliveryFee || 0;
            const repackFee = pay.repackFee || 0;
            const agencyFee = pay.agencyFee || 0;
            const removeFee = pay.removeFee || 0;
            const comprFee = pay.comprFee || 0;
            const etcPrice = pay.etcPrice || 0;
            const etcFee = pay.etcFee || 0;
            etcTotal += courierPay + returnFee + deliveryFee + repackFee + agencyFee + removeFee + comprFee + etcPrice + etcFee;
            return etcTotal;
        } else if (pay.payType === "PT3") {
            const ttProdPrice = pay.ttProdExpense || 0;
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttEtcPrice = pay.ttEtcPrice || 0;
            const ttShipExpense = pay.ttShipExpense || 0;
            integTotal += ttProdPrice + ttEtcFee + ttEtcPrice + ttShipExpense;
            return integTotal;
        }
    };

    // 현재 사용자 브라우저위치
    const pathComponent = window.location.pathname;
    // ===================================User Info

    // 로그아웃 axios
    const logout = () => axios({
        method: 'post',
        url: '/member/logout',
        headers: {
            Authorization: LCAT ? LCAT : SSAT
        }
    })
        .then(() => {
            if (SSAT) {
                sessionStorage.removeItem('AToken')
                sessionStorage.removeItem('lastLoginTime')
            } else {
                localStorage.removeItem('AToken');
                localStorage.removeItem('lastLoginTime')
            }
            navigate("/UserLoginPg")
        })
        .catch(() => {
            if (SSAT) {
                sessionStorage.removeItem('AToken')
                sessionStorage.removeItem('lastLoginTime')
            } else {
                localStorage.removeItem('AToken');
                localStorage.removeItem('lastLoginTime')
            }
            navigate("/UserLoginPg")
        })

    //메인메뉴 드롭다운 state
    const [profilePhotoLine, setProfilePhotoLine] = useState(profileImage);
    const [profileName, setProfileName] = useState("");

    const [dbCoupon, setDbCoupon] = useState('');
    useEffect(() => {
        const activeCouponCount = memberInfo[0] && memberInfo[0].coupons && memberInfo[0].coupons.filter(coupon => coupon && coupon.activeFl === true).length;
        setDbCoupon(activeCouponCount || 0);
    }, [memberInfo]);

    return (
        <div className='m-a-user-my-pg-container font-t-cont'>
            <MHeader title={t(`hdMypg`)} url={"/"}/> {/*마이페이지*/}
            <div className='m-a-user-my-page-user-info m-b-15'>
                <div className={'m-a-user-my-page-user-profile-img-box'} onClick={() => navigate("/UserChatAlarmPg")}>
                    <img className='m-a-user-my-page-profile-img' src={profilePhotoLine} alt=''/>
                    <div className={'m-a-user-my-page-profile-unread-cnt'}>
                        {totalUnreadCount && totalUnreadCount > 0 ? (
                            <div className="mYpg-Alarm text-center">
                                {totalUnreadCount}
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className='m-a-user-my-page-user-info-frame'>
                    <div className="font-b">{profileName}</div>
                    <div className="m-a-user-my-page-user-info-row">
                        <div className='m-a-user-my-page-user-info-button'>
                            <div className='m-a-user-my-page-user-info-button-text'
                                 onClick={() => navigate("/UserModiPg")}>{t(`hdBt1`)}</div>
                            <div className='m-a-user-my-page-user-info-vertical-divider'/>
                            <div className='m-a-user-my-page-user-info-button-text' onClick={logout}>{t(`hdBt2`)}</div>
                            {/*로그아웃*/}
                        </div>
                    </div>
                    <div className='m-a-user-my-page-user-info-row'>
                        <div className='m-a-user-my-page-user-info-row-label'>{t(`myOrdPc1`)}</div>
                        {/*사서함번호*/}
                        <div className='m-a-user-my-page-user-info-row-value'>
                            BT <div className='m-a-user-my-page-user-info-row-value-strong'>{memberDto.mbNum}</div>
                        </div>
                    </div>
                    <div className='m-a-user-my-page-user-info-row'>
                        <div className='m-a-user-my-page-user-info-row-label'>{t(`myOrdPc2`)}</div>
                        <div className='m-a-user-my-page-user-info-row-value'>
                            <div className='m-a-user-my-page-user-info-row-value-strong'>
                                {memberDto && memberDto?.deposit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </div>
                    </div>
                    <div className='m-a-user-my-page-user-info-row'>
                        <div className='m-a-user-my-page-user-info-row-label'>{t(`myOrdPc3`)}</div>
                        <div className='m-a-user-my-page-user-info-row-value'>
                            <div className='m-a-user-my-page-user-info-row-value-strong'>
                                {memberDto && memberDto?.point?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </div>
                    </div>
                    <div className='m-a-user-my-page-user-info-row'>
                        <div className='m-a-user-my-page-user-info-row-label'>My{t(`modSHeader13`)}</div>
                        {/*My쿠폰*/}
                        <div className={'m-a-order-section-payment-discount-label'}>
                            {dbCoupon && dbCoupon > 0 ?
                                <div className={'m-a-order-section highlight'}>{dbCoupon}</div> :
                                <div className={'m-a-order-section'}>0</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className='m-a-user-my-page-divider-bold'/>
            {subTitle(t(`myOrdPc`), commonHeader)} {/*주문현황*/}
            <div className="m-a-user-my-page-divider"/>
            <div className="m-a-user-my-page-order-status-frame font-c-default">
                <div className="m-a-user-my-page-order-status">
                    <img className='m-a-user-my-page-order-icon' src={mypgOrder} alt=''/>
                    <div className="m-a-user-my-page-order-title font-c-default"> {t(`myOrdPcHeader1`)}</div>
                    {/*주문*/}
                    {/*입고대기*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS00")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc1`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS00 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS00 || 0}</div>
                    </div>
                    {/*결제대기*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS01")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc2`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS01 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS01 || 0}</div>
                    </div>
                    {/*결제중*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS02")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc3`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS02 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS02 || 0}</div>
                    </div>
                    {/*결제완료*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS03")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc4`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS03 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS03 || 0}</div>
                    </div>
                    {/*구매중*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS04")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc5`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS04 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS04 || 0}</div>
                    </div>
                    {/*구매완료*/}
                    <div className='m-a-user-my-page-order-row'
                         onClick={() => selectNoDateTotalOrderList("OS05")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc6`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS05 > 0 ? "#FFAF34" : "#5b5b5b"}}> {processData.OS05 || 0}</div>
                    </div>
                </div>
                <img className="m-a-user-my-page-process-icon" src={MyPageProcessNext} alt=''/>
                <div className="m-a-user-my-page-order-status">
                    <img className='m-a-user-my-page-order-icon' src={mypgDelivery} alt=''/>
                    <div className='m-a-user-my-page-order-title'> {t(`myOrdPcHeader2`)}</div>
                    {/*해외배송*/}
                    {/*입고중*/}
                    <div className="m-a-user-my-page-order-row" onClick={() => selectNoDateTotalOrderList("OS06")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc7`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS06 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS06 || 0}</div>
                    </div>
                    {/*센터도착*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("OS07")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc8`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS07 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS07 || 0}</div>
                    </div>
                    {/*패킹중*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("OS08")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc9`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS08 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS08 || 0}</div>
                    </div>
                    {/*결제대기*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS0")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc10`)}</div>
                        <div
                            className='m-a-user-my-page-order-row-value'
                            style={{color: processData.OS09 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS09 + processData.PS0 || 0}</div>
                    </div>
                    {/*결제중*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS1")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc11`)}</div>
                        <div
                            className='m-a-user-my-page-order-row-value'
                            style={{color: processData.OS10 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS10 + processData.PS1 || 0}</div>
                    </div>
                    {/*결제완료*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS2")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc12`)}</div>
                        <div
                            className='m-a-user-my-page-order-row-value'
                            style={{color: processData.OS11 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS11 + processData.PS2 || 0}</div>
                    </div>
                    {/*출고완료*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS3")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc13`)}</div>
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS12 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS12 + processData.PS3 || 0}</div>
                    </div>
                </div>
                <img className="m-a-user-my-page-process-icon" src={mypgReturnIcon} alt=''/>
                <div className="m-a-user-my-page-order-status">
                    <img className='m-a-user-my-page-order-icon' src={mypgPayinfo} alt=''/>
                    <div className='m-a-user-my-page-order-title'>{t(`myOrdPcHeader3`)}</div>
                    {/*반송*/}
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS4")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc14`)}</div>
                        {/*반송중*/}
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS13 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS13 + processData.PS4 || 0}</div>
                    </div>
                    <div className='m-a-user-my-page-order-row' onClick={() => selectNoDateTotalOrderList("PS5")}>
                        <div className='m-a-user-my-page-order-row-label'>{t(`myPc15`)}</div>
                        {/*취소*/}
                        <div className='m-a-user-my-page-order-row-value'
                             style={{color: processData.OS14 > 0 ? "#FFAF34" : "#5b5b5b"}}>{processData.OS14 + processData.PS5 || 0}</div>
                    </div>
                </div>
            </div>
            <div className='m-a-user-my-page-divider-bold m-t-17'/>
            {subTitle(t(`myTab1`), mypgPayinfo)} {/*주문서*/}
            <div className='m-a-user-my-page-divider'/>
            <div className='m-a-user-my-page-order-sheet-frame'>
                <div className="display-flex flex-column wd-100pc gap8"
                     style={{top: 0, position: "sticky", zIndex: 1, backgroundColor: "#FFF"}}>
                    <div className='m-a-user-my-page-order-sheet-filter'>
                        <div className="m-a-user-my-page-order-sheet-filter-button" ref={periodButtonRef}
                             onClick={() => setPeriodSelectShow(true)}>
                            {periodSelectCommonValue}
                            <img className={'m-a-user-my-page-order-sheet-filter-icon'} src={Expand} alt={''}/>
                            {periodSelectShow &&
                                <div className={'m-a-user-my-page-order-sheet-filter-list'} ref={periodDivRef}
                                     onClick={periodDivHandle}>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => periodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}</div>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => periodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}</div>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => periodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}</div>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => periodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}</div>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => periodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}</div>
                                </div>
                            }
                        </div>
                        <div className="m-a-user-my-page-order-sheet-filter-button" ref={orderTypeButtonRef}
                             onClick={() => setOrderTypeSelectShow(true)}>
                            {orderTypeSelectCommonValue}
                            <img className={'m-a-user-my-page-order-sheet-filter-icon'} src={Expand} alt={''}/>
                            {orderTypeSelectShow &&
                                <div className={'m-a-user-my-page-order-sheet-filter-list'} ref={orderTypeDivRef}
                                     onClick={orderTypeDivHandle}>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => orderTypeBtHandle(t('orderType'))}>{t(`orderType`)}</div>
                                    {/*주문서유형*/}
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => orderTypeBtHandle(t('myTab1'))}>{t(`myTab1`)}</div>
                                    <div className="m-a-user-my-page-order-sheet-filter-item"
                                         onClick={() => orderTypeBtHandle(t('deliveryOption'))}>{t(`deliveryOption`)}</div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="m-a-user-my-page-order-sheet-filter-button" ref={orderStButtonRef}
                         onClick={() => setOrderStSelectShow(true)}>
                        {filterOrderSt(orderStSelectCommonValue)}
                        <img className={'m-a-user-my-page-order-sheet-filter-icon'} src={Expand} alt={''}/>
                        {orderStSelectShow &&
                            <div className={'m-a-user-my-page-order-sheet-filter-list'} ref={orderStDivRef}
                                 onClick={orderStDivHandle}>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle(t(`state`))}>{t(`state`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS00")}>{t(`prodStLabel1`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS01")}>{t(`prodStLabel2`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS02")}>{t(`prodStLabel3`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS03")}>{t(`prodStLabel4`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS04")}>{t(`prodStLabel14`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS05")}>{t(`prodStLabel5`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS06")}>{t(`prodStLabel15`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS07")}>{t(`prodStLabel6`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("OS08")}>{t(`prodStLabel7`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS0")}>{t(`prodStLabel8`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS1")}>{t(`prodStLabel9`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS2")}>{t(`prodStLabel10`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS3")}>{t(`prodStLabel11`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS4")}>{t(`prodStLabel12`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => orderStBtHandle("PS5")}>{t(`prodStLabel13`)}
                                </div>
                            </div>
                        }
                    </div>
                    <div className='m-a-user-my-page-order-sheet-search'>
                        <input className='m-a-user-my-page-order-sheet-keyword' placeholder={t(`myPlaceHd`)}
                               spellCheck="false" type="text"
                               value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
                    </div>
                    {/*전체체크박스 라인*/}
                    <div>
                        <div className="display-flex align-center justify-content-between m-b-10 gap8">
                            <button className="bt-btn-A font-s-12 wd-50pc ht-35"
                                    onClick={invoiceDown}>
                                {t(`modIvAccd`)}
                            </button>
                            <button className="bt-btn-A font-s-12 wd-50pc ht-35"
                                    onClick={excelDown}>
                                {t(`mpTx5`)}
                            </button>
                            <button className="bt-btn-A font-s-12 wd-50pc ht-35"
                                    onClick={excelOrderDown}>
                                {t(`mpTx6`)}
                            </button>
                        </div>
                        <div className="display-flex align-center" style={{padding: "10px 0"}}>
                            <input id="orderCheckBox" type="checkbox" checked={selectAll} className="myPgCustomCheckBox"
                                   onChange={handleSelectAllChange} style={{width: "17px", height: "17px"}}/>
                            <p className="m-l-5 font-s-12 font-c-dimgray">{t('mpTx4')}</p>
                        </div>
                    </div>
                    <div className='m-a-user-my-page-divider m-b-10'/>
                </div>
                {orderdtList.length === 0 || filteredList.length === 0 ? (
                    <div className={'m-a-user-my-page-no-data'}><img className={'m-a-user-my-page-no-data-img'} alt=""
                                                                     src={noData}/>No Data</div>
                ) : (
                    <div ref={myPgContentRef}>
                        {filteredList.slice(0, orderListDisplayLimit).map((order, index) => {
                            let data1 = 0, data2 = 0, data3 = 0, data4 = 0;
                            if (order.type === 'orderdt') {
                                // 상품미결제 + 관리자가 등록한 상품누락금 미결제에 추가
                                data1 = order.productsDTO?.reduce((sum, item) => {
                                    return (item.prodSt === "IS01" || item.prodSt === "IS02") && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                }, 0) || 0;
                                data1 += order.payInfoDTO?.reduce((sum, item) => {
                                    return (item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1'
                                    && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                }, 0) || 0;

                                // 상품총결제 + 관리자가 등록한 상품누락금 결제완료에 추가
                                data2 = order.productsDTO?.reduce((sum, item) => {
                                    return item.prodSt !== "IS01" && item.prodSt !== "IS02" && item.prodSt !== "IS12" && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                }, 0) || 0;
                                data2 += order.payInfoDTO?.reduce((sum, item) => {
                                    return item.payStatus !== "PS0" && item.payStatus !== "PS1" && item.payClass === '1'
                                    && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                }, 0) || 0;

                                // 기타미결제
                                data3 = order.payInfoDTO?.reduce((sum, item) => {
                                    if ((item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1') {
                                        // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                        const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                        const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                        return sum + etcPrice + etcFee;
                                    }
                                    return sum;
                                }, 0) || 0;

                                // 기타총결제
                                data4 = order.payInfoDTO?.reduce((sum, item) => {
                                    if ((item.payStatus !== "PS0" && item.payStatus !== "PS1") && item.payClass === '1') {
                                        // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                        const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                        const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                        return sum + etcPrice + etcFee;
                                    }
                                    return sum;
                                }, 0) || 0;
                            }
                            // 주문서
                            if (order.type === 'orderdt') {
                                return (
                                    <div className='m-a-user-my-page-order-sheet'
                                         key={`order-${order.seqnum}-${index}`}>
                                        <div>
                                            <input id="orderCheckBox" type="checkbox"
                                                   className="myPgCustomCheckBox"
                                                   checked={selectedRows.includes(order.seqnum)}
                                                   onChange={() => handleCheckboxChange(order.seqnum)}
                                                   style={{width: "17px", height: "17px"}}/>
                                        </div>
                                        <div className='m-a-user-my-page-order-sheet-row'
                                             onClick={myOrdPgMove(order.orderNumber)}>
                                            <div className='m-a-user-my-page-order-sheet-row-left'>
                                                <img className='m-a-user-my-page-order-sheet-row-icon'
                                                     src={mypgPayinfo} alt=''/>
                                                <div
                                                    className='m-a-user-my-page-order-sheet-row-title'>
                                                    {order?.orderNumber ? order.orderNumber : order.orderdtDTO?.orderNumber}
                                                </div>
                                            </div>
                                            <div className='m-a-user-my-page-order-sheet-text'>
                                                {order.regDate ? `${order.regDate.substring(0, 4)}-${order.regDate.substring(4, 6)}-${order.regDate.substring(6, 8)}` : ''}
                                            </div>
                                        </div>
                                        <div className='m-a-user-my-page-order-sheet-row'>
                                            <div
                                                className='m-a-user-my-page-order-sheet-text'>{order.recinfoDTO && order.recinfoDTO.recname}</div>
                                            <div
                                                className='m-a-user-my-page-order-sheet-text'>{order.recinfoDTO && order.recinfoDTO.countryDTO.countryEngNm}</div>
                                            <div className='m-a-user-my-page-order-sheet-text'>{order.shipco}</div>
                                        </div>
                                        <div
                                            className='m-a-user-my-page-order-sheet-status'>{orderStPrint(order?.orderStatus)}</div>
                                        {order.productsDTO && order.productsDTO.slice(0, 10).map((prod, prodIndex) => (
                                            <div className='m-a-user-my-page-order-sheet-item wd-100pc'
                                                 key={`product-${prod.seqnum}-${prodIndex}`}>
                                                <div className="admin-tb-text-cut wd-100pc">
                                                    <a className="m-r-4">
                                                        {
                                                            prod.prodTy === "P00" ? t(`myProdTy1`) :
                                                                prod.prodTy === "P01" ? t(`myProdTy2`) :
                                                                    prod.prodTy === "P02" ? t(`myProdTy3`) :
                                                                        prod.prodTy === "P03" ? t(`myProdTy4`) :
                                                                            prod.prodTy === "P04" ? t(`myProdTy5`) :
                                                                                prod.prodTy === "P05" ? t(`myProdTy6`) :
                                                                                    null
                                                        }
                                                    </a>
                                                    <a>{prod.name}</a>
                                                </div>
                                            </div>
                                        ))}
                                        <div className='m-a-user-my-page-order-sheet-receipt'>
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div className='m-a-user-my-page-order-sheet-row-left'>
                                                    <img className='m-a-user-my-page-order-sheet-row-icon'
                                                         src={mypgPayCardOrder} alt=''/>
                                                    <div
                                                        className='m-a-user-my-page-order-sheet-row-title'> {t(`myOrddtCardHeader1`)}</div>
                                                    {/*주문서금액*/}
                                                </div>
                                                <img className='m-a-user-my-page-order-sheet-row-icon lg' src={mypgWarn}
                                                     onClick={() => openGuidePopupOrder(index)} alt=''/>
                                            </div>
                                            {/*상품미결제*/}
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-label'>{t(`myOrddtCardHeader2`)}</div>
                                                <div
                                                    className={`m-a-user-my-page-order-receipt-value ${data1 > 0 && 'primary'}`}>
                                                    {data1?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </div>
                                            </div>
                                            {/*상품총결제*/}
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-label'>{t(`myOrddtCardHeader3`)}</div>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-value'>
                                                    {data2?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </div>
                                            </div>
                                            {/*기타미결제*/}
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-label'>{t(`myOrddtCardHeader4`)}</div>
                                                <div
                                                    className={`m-a-user-my-page-order-receipt-value ${data3 > 0 && 'primary'}`}>
                                                    {data3?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </div>
                                            </div>
                                            {/*기타총결제*/}
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-label'>{t(`myOrddtCardHeader`)}</div>
                                                <div
                                                    className='m-a-user-my-page-order-receipt-value'>
                                                    {data4?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </div>
                                            </div>

                                            {/*주문서 상세버튼*/}
                                            <div
                                                className="display-flex justify-content-between align-center wd-100pc ht-50">
                                                {order.shipco === "국내배송" && order.orderStatus === "OS12" ?
                                                    <button className="bt-btn-A font-s-12 wd-50pc ht-35 m-r-10"
                                                            onClick={() => selectDsTrackNum(order.shipco, order.outWaynum)}>
                                                        {t(`smTrackHeader`)}
                                                    </button>
                                                    :
                                                    <div className="wd-50pc"></div>
                                                }
                                                <button className="admin-btn-C font-s-12 wd-50pc ht-35"
                                                        onClick={myOrdPgMove(order.orderNumber)}>
                                                    {t(`myDt`)}
                                                </button>
                                            </div>

                                            {guidePopupOrderSt[index] && (
                                                <div className={'m-a-user-my-page-guide-popup'}>
                                                    <div className={'m-a-user-my-page-guide-popup-header'}>
                                                        {t(`myCardHeader`)}
                                                        <img className={'m-a-user-my-page-guide-popup-close'}
                                                             src={commonClose} alt={'close'}
                                                             onClick={() => closeGuidePopupOrder(index)}/>
                                                    </div>
                                                    <div className={'m-a-user-my-page-guide-popup-content'}>
                                                        {t(`myOrddtCont1`)} {t(`myDt`)} {t(`myOrddtCont2`)} {t(`myOrddtCont3`)}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className='m-a-user-my-page-divider m-a-user-my-pg-margin'/>
                                    </div>
                                )
                            } else if (order.type === 'payinfo' && (order.payType === "PT1")) {
                                // 해외배송비
                                return (
                                    <div className='m-a-user-my-page-order-sheet' key={`pay-${order.seqNum}-${index}`}>
                                        <div>
                                        <input id="orderCheckBox" type="checkbox"
                                               className="myPgCustomCheckBox"
                                               checked={selectedRows.includes(order.seqNum)}
                                               onChange={() => handleCheckboxChange(order.seqNum)}
                                               style={{width: "17px", height: "17px"}}/>
                                        </div>
                                        <div className='m-a-user-my-page-order-sheet-row'
                                             onClick={() => deliveryDetailTrueFn(order.seqNum, convertToShipco(order.dvType, order.orderdtDTO.shipco))}>
                                            <div className='m-a-user-my-page-order-sheet-row-left'>
                                                <img className='m-a-user-my-page-order-sheet-row-icon'
                                                     src={mypgOrderdt} alt=''/>
                                                <div
                                                    className='m-a-user-my-page-order-sheet-row-title'>
                                                    {order?.orderNumber ? order.orderNumber : order.orderdtDTO?.orderNumber}
                                                    -{order.shipInfoDTO.boxNum}
                                                </div>
                                            </div>
                                            <div className='m-a-user-my-page-order-sheet-text'>
                                                {order.regDate ? `${order.regDate.substring(0, 4)}-${order.regDate.substring(4, 6)}-${order.regDate.substring(6, 8)}` : ''}                                            </div>
                                        </div>
                                        <div className='m-a-user-my-page-order-sheet-row'>
                                            <div
                                                className='m-a-user-my-page-order-sheet-text'>{order.appRecDTO.recname}</div>
                                            <div
                                                className='m-a-user-my-page-order-sheet-text'>{order.appRecDTO.countryDTO.countryEngNm}</div>
                                            <div className='m-a-user-my-page-order-sheet-text'>
                                                {convertToShipco(order.dvType, order.orderdtDTO.shipco)}
                                            </div>
                                        </div>
                                        <div className='m-a-user-my-page-order-sheet-status'>
                                            {order.payStatus === "PS0" ? t(`prodStLabel8`)
                                                : order.payStatus === "PS1" ? t(`prodStLabel9`)
                                                    : order.payStatus === "PS2" ? t(`prodStLabel10`)
                                                        : order.payStatus === "PS3" ? t(`prodStLabel11`)
                                                            : order.payStatus === "PS4" ? t(`prodStLabel12`)
                                                                : order.payStatus === "PS5" ? t(`prodStLabel13`)
                                                                    : null
                                            }
                                        </div>
                                        {order.packListDTO && order.packListDTO.productsDTO && order.packListDTO.productsDTO.slice(0, 10).map((prod, prodIndex) => (
                                            <div className="m-a-user-my-page-order-sheet-item wd-100pc"
                                                 key={`product-${prod.seqnum}-${prodIndex}`}>
                                                <a className="m-r-4">
                                                    {
                                                        prod.prodTy === "P00" ? t(`myProdTy1`) :
                                                            prod.prodTy === "P01" ? t(`myProdTy2`) :
                                                                prod.prodTy === "P02" ? t(`myProdTy3`) :
                                                                    prod.prodTy === "P03" ? t(`myProdTy4`) :
                                                                        prod.prodTy === "P04" ? t(`myProdTy5`) :
                                                                            prod.prodTy === "P05" ? t(`myProdTy6`) :
                                                                                null
                                                    }
                                                </a>
                                                <a>{prod.name}</a>
                                            </div>
                                        ))}
                                        <div className='m-a-user-my-page-order-sheet-receipt'>
                                            <div className='m-a-user-my-page-order-sheet-row'>
                                                <div className='m-a-user-my-page-order-sheet-row-left'>
                                                    <img className='m-a-user-my-page-order-sheet-row-icon'
                                                         src={mypgPayCardDelivery}
                                                         alt=''/>
                                                    <div
                                                        className='m-a-user-my-page-order-sheet-row-title'> {t(`modSHeader6`)}</div>
                                                </div>
                                                <img className='m-a-user-my-page-order-sheet-row-icon lg'
                                                     src={mypgWarn}
                                                     onClick={() => openGuidePopupPay(index)}
                                                     alt=''/>
                                            </div>
                                            {order?.ttFedexPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>FedEx</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttFedexPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttFedexPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttFedexEcoPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>FedEx-E</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttFedexEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttFedexEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttUpsPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>UPS</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttUpsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttUpsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttUpsEcoPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>UPS-E</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttUpsEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttUpsEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttEmsPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>EMS</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttEmsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttEmsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}                                              </div>
                                                </div>
                                            )}
                                            {order?.ttEmsPrePrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>EMSP</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttEmsPrePrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttEmsPrePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}                                              </div>
                                                </div>
                                            )}
                                            {order?.ttSeaPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>SEA</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttSeaPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttSeaPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttKPackPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>K-Packet</div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttKPackPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttKPackPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}
                                            {order?.ttAirSPrice > 0 && (
                                                <div className='m-a-user-my-page-order-sheet-row receipt'>
                                                    <div className='m-a-user-my-page-order-receipt-label'>Small-Packet
                                                    </div>
                                                    <div
                                                        className={`m-a-user-my-page-order-receipt-value ${order?.ttAirSPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") && 'primary'}`}>
                                                        {order?.ttAirSPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </div>
                                                </div>
                                            )}

                                            {/* 조회/상세 버튼 */}
                                            <div
                                                className="display-flex justify-content-between align-center wd-100pc ht-50">
                                                {/*배송조회*/}
                                                <button className="bt-btn-A font-s-12 wd-50pc ht-35"
                                                        onClick={() => {
                                                            const shipco = convertToShipco(order.dvType);

                                                            if (shipco === '국내배송') {
                                                                selectDsTrackNum(shipco, order.shipInfoDTO.outWayNum);
                                                            } else {
                                                                selectOsTrackNum(shipco, order.shipInfoDTO.outWayNum);
                                                            }
                                                        }}
                                                >
                                                    {t(`smTrackHeader`)}
                                                </button>
                                                {/*상세*/}
                                                <button className="admin-btn-C font-s-12 wd-50pc ht-35 m-l-10"
                                                        onClick={() => deliveryDetailTrueFn(order.seqNum, order.orderdtDTO.shipco)}>
                                                    {t(`myDt`)}
                                                </button>
                                            </div>

                                            {guidePopupPaySt[index] && (
                                                <div className={'m-a-user-my-page-guide-popup'}>
                                                    <div className={'m-a-user-my-page-guide-popup-header'}>
                                                        {t(`myCardHeader`)}
                                                        <img className={'m-a-user-my-page-guide-popup-close'}
                                                             src={commonClose} alt={'close'}
                                                             onClick={() => closeGuidePopupPay(index)}/>
                                                    </div>
                                                    <div className={'m-a-user-my-page-guide-popup-content'}>
                                                        {t(`myOrddtCont1`)} {t(`myDt`)} {t(`myOrddtCont2`)} {t(`myPayinfoCont`)}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className='m-a-user-my-page-divider m-a-user-my-pg-margin'/>
                                    </div>
                                )
                            } else {
                                return null;
                            }
                        })}

                        {/*주문서탭 더보기버튼*/}
                        {
                            orderListDisplayLimit && filteredList && filteredList.length > orderListDisplayLimit ?
                                <div className="m-t-30 m-b-100 user-center font-s-17">
                                    <button onClick={handleMoreOrderList}
                                            className="moreBt1 m-r-8 wd-80 ht-35 font-c-default m-r-8 font-s-14">More
                                    </button>
                                </div>
                                :
                                null
                        }

                    </div>
                )}
            </div>
            {subTitle(t(`myTab2`), mypgPayinfo)} {/*결제내역*/}
            <div className="m-a-user-my-page-divider"/>
            <div className="m-a-user-my-page-payment-frame">
                <div className="m-a-user-my-page-order-sheet-filter">
                    <div className="m-a-user-my-page-order-sheet-filter-button" ref={payPeriodButtonRef}
                         onClick={() => setPayPeriodSelectShow(true)}>
                        {payPeriodSelectCommonValue}
                        <img className="m-a-user-my-page-order-sheet-filter-icon" src={Expand} alt={''}/>
                        {payPeriodSelectShow &&
                            <div className="m-a-user-my-page-order-sheet-filter-list" ref={payPeriodDivRef}
                                 onClick={payPeriodDivHandle}>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payPeriodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payPeriodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payPeriodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payPeriodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payPeriodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}</div>
                            </div>
                        }
                    </div>
                    <div className='m-a-user-my-page-order-sheet-filter-button' ref={payStButtonRef}
                         onClick={() => setPayStSelectShow(true)}>
                        {filterPaySt(payStSelectCommonValue)}
                        <img className={'m-a-user-my-page-order-sheet-filter-icon'} src={Expand} alt={''}/>
                        {payStSelectShow &&
                            <div className={'m-a-user-my-page-order-sheet-filter-list'} ref={payStDivRef}
                                 onClick={payStDivHandle}>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payStBtHandle(t(`state`))}>{t(`state`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payStBtHandle("PS0")}>{t(`prodStLabel8`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payStBtHandle("PS1")}>{t(`prodStLabel9`)}</div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => payStBtHandle("PS2")}>{t(`prodStLabel10`)}</div>
                            </div>
                        }
                    </div>
                </div>
                <div className="m-a-user-my-page-payment-table-container">
                    <div className="m-a-user-my-page-payment-table label">
                        <div className="m-a-user-my-page-payment-table-item">{t(`myHtDate`)}</div>
                        {/*날짜*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`ttPr`)}</div>
                        {/*총금액*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`myUseDep`)}</div>
                        {/*예치금사용*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`myUsePt`)}</div>
                        {/*적립금사용*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`myUseCp`)}</div>
                        {/*쿠폰사용*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`appSale`)}</div>
                        {/*앱할인*/}
                        <div className="m-a-user-my-page-payment-table-item"/>
                        <div className="m-a-user-my-page-payment-table-item">{t(`myFnPr`)}</div>
                        {/*최종금액*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`myPt`)}</div>
                        {/*결제수단*/}
                        <div className="m-a-user-my-page-payment-table-item">{t(`modPlHeader5`)}</div>
                        {/*상태*/}
                    </div>
                    {sortedPayList.filter(filterStatus).slice(0, payListDisplayLimit).map((pay, index) => (
                        <div className="m-a-user-my-page-payment-table" key={index}>
                            <div className="m-a-user-my-page-payment-table-item">{formatDate(pay?.regDate)}</div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {selectedTotalPricePrint(pay).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                            </div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {pay?.depUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                            </div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {pay?.pointUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                            </div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {pay?.couponUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                            </div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {pay?.appSalePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                            </div>
                            <div className="m-a-user-my-page-payment-table-item">
                                {pay.payType === "PT3" && (
                                    <button className='bt-btn-C pd2 wd-70 ht-35 font-s-11'
                                            onClick={() => integPayDetail(pay.seqNum)}>{t(`myHtItBt`)}</button>
                                )}
                            </div>
                            <div className='m-a-user-my-page-payment-history-forPrice-container'>
                                {pay?.lastPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                {pay.payWay === "PM01" ?
                                    <div className="user-center m-l-5 font-s-12">
                                        <p className="m-a-user-my-page-payment-history-forPrice-text">{pay?.lastForPrice}</p>
                                        <p className="m-l-3">{pay?.forCurrency}</p>
                                    </div>
                                    : null
                                }
                            </div>
                            <div className='m-a-user-my-page-payment-table-item'>
                                {pay.payWay === "PM00" ? t(`modNoBank`) :
                                    pay.payWay === "PM01" ? "Paypal" :
                                        pay.payWay === "PM02" ? "Wechat" :
                                            pay.payWay === "PM03" ? "Alipay" :
                                                pay.payWay === "PM04" ? "Point" :
                                                    pay.payWay === "PM05" ? "Deposit" :
                                                        pay.payWay === "PM06" ? "BtoragePay(Global)" :
                                                            pay.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                                pay.payWay === "PM08" ? "GlobalCard" :
                                                                    pay.payWay === "PM09" ? "KoreanPay" : null}
                            </div>
                            <div className='m-a-user-my-page-payment-table-item'>
                                {pay.payStatus === "PS1" ?
                                    <p style={{color: "#98B0D4"}}>{t(`prodStLabel9`)}</p>
                                    : pay.payStatus === "PS5" ? <p style={{color: "#EB939D"}}>{t(`prodStLabel13`)}</p>
                                        : <p style={{color: "#FFB378"}}>{t(`prodStLabel10`)}</p>
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/*결제내역탭 더보기버튼*/}
            {
                payListDisplayLimit && sortedPayList && sortedPayList.length > payListDisplayLimit ?
                    <div className="m-t-20 m-b-50 user-center font-s-17">
                        <button onClick={handleMorePayList}
                                className="moreBt1 m-r-8 wd-80 ht-35 font-c-default m-r-8 font-s-13">More
                        </button>
                    </div>
                    :
                    null
            }

            <div className='m-a-user-my-page-divider-bold m-a-user-my-pg-margin'/>
            {subTitle(t(`myTab3`), mypgPayinfo)} {/*예치금&적립금*/}
            <div className='m-a-user-my-page-divider'/>
            <div className='m-a-user-my-page-usage-frame'>
                <div className='m-a-user-my-page-order-sheet-filter'>
                    <div className='m-a-user-my-page-order-sheet-filter-button full'
                         ref={dacPeriodButtonRef}
                         onClick={() => setDacPeriodSelectShow(true)}>
                        {dacPeriodSelectCommonValue}
                        <img className={'m-a-user-my-page-order-sheet-filter-icon'} src={Expand} alt={''}/>
                        {dacPeriodSelectShow &&
                            <div className={'m-a-user-my-page-order-sheet-filter-list'}
                                 ref={dacPeriodDivRef} onClick={dacPeriodDivHandle}>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => dacPeriodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => dacPeriodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => dacPeriodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => dacPeriodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}
                                </div>
                                <div className="m-a-user-my-page-order-sheet-filter-item"
                                     onClick={() => dacPeriodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="m-a-user-my-page-usage-sub-title"> {t(`myDepHt`)}</div>
                {/*예치금내역*/}
                <div className="m-a-user-my-page-usage-table-frame">
                    <div className="m-a-user-my-page-usage-table label p-t-7">
                        <div className="m-a-user-my-page-usage-table-item">{t(`myHtDate`)}</div>
                        {/*날짜*/}
                        <div className="m-a-user-my-page-usage-table-item-col-3">{t(`myCont`)}</div>
                        {/*내용*/}
                        <div className="m-a-user-my-page-usage-table-item">{t(`myPr`)}</div>
                        <div className="m-a-user-my-page-usage-table-item">{t(`myBal`)}</div>
                    </div>
                    {sortedDacList.filter(dac => dac.depPrice > 0).slice(0, dacDisplayLimits.deposit).map((dac, index) => (
                        <div key={index} className="m-a-user-my-page-usage-table p-t-7">
                            <div className="m-a-user-my-page-usage-table-item">{formatDate(dac?.regDate)}</div>
                            <div className='m-a-user-my-page-usage-table-item-col-3 admin-tb-text-cut'>
                                {dac.content}
                            </div>
                            <div className="m-a-user-my-page-usage-table-item">
                                {(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.depPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>
                            <div className="m-a-user-my-page-usage-table-item">
                                {dac?.depBalance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>
                        </div>
                    ))}
                </div>

                {/*예치금&적립금탭 예치금 더보기버튼*/}
                {
                    dacDisplayLimits["deposit"] && sortedDacList && sortedDacList.filter(dac => dac.depPrice > 0).length > dacDisplayLimits["deposit"] ?
                        <div className="m-t-20 m-b-50 user-center font-s-17">
                            <button onClick={() => handleMoreDacList("deposit")}
                                    className="moreBt1 m-r-8 wd-80 ht-35 font-c-default m-r-8 font-s-13">More
                            </button>
                        </div>
                        :
                        null
                }

            </div>
            {/*적립금내역*/}
            <div className='m-a-user-my-page-usage-frame'>
                <div className='m-a-user-my-page-usage-sub-title'> {t(`myPtHt`)}</div>
                <div className='m-a-user-my-page-usage-table-frame'>
                    <div className='m-a-user-my-page-usage-table label p-t-7'>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myHtDate`)}</div>
                        <div className='m-a-user-my-page-usage-table-item-col-3'>{t(`myCont`)}</div>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myPr`)}</div>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myBal`)}</div>
                    </div>
                    {sortedDacList.filter(dac => dac.ptPrice > 0).slice(0, dacDisplayLimits.point).map((dac, index) => (
                        <div key={index} className='m-a-user-my-page-usage-table p-t-7'>
                            <div className='m-a-user-my-page-usage-table-item'>{formatDate(dac?.regDate)}</div>
                            <div className='m-a-user-my-page-usage-table-item-col-3'>{dac.content}</div>
                            <div className='m-a-user-my-page-usage-table-item'>
                                {(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.ptPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>
                            <div className='m-a-user-my-page-usage-table-item'>
                                {dac?.ptBalance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>
                        </div>
                    ))}
                </div>

                {/*예치금&적립금탭 적립금 더보기버튼*/}
                {
                    dacDisplayLimits["point"] && sortedDacList && sortedDacList.filter(dac => dac.ptPrice > 0).length > dacDisplayLimits["point"] ?
                        <div className="m-t-20 m-b-50 user-center font-s-17">
                            <button onClick={() => handleMoreDacList("point")}
                                    className="moreBt1 m-r-8 wd-80 ht-35 font-c-default m-r-8 font-s-13">More
                            </button>
                        </div>
                        :
                        null
                }

            </div>
            {/*쿠폰내역*/}
            <div className='m-a-user-my-page-usage-frame' style={{marginBottom: '60px'}}>
                <div className='m-a-user-my-page-usage-sub-title'> {t(`myCpHt`)}</div>
                <div className='m-a-user-my-page-usage-table-frame p-t-7'>
                    <div className='m-a-user-my-page-usage-table m-a-user-my-pg-col-6 label m-a-user-my-pg-coupon'>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myHtDate`)}</div>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myCpNm`)}</div>
                        <div className='m-a-user-my-page-usage-table-item'>{t(`myPr`)}</div>
                    </div>
                    {sortedDacList.filter(dac => dac.cpPrice > 0).slice(0, dacDisplayLimits.coupon).map((dac, index) => (
                        <div key={index}
                             className='m-a-user-my-page-usage-table m-a-user-my-pg-col-6 m-a-user-my-pg-coupon p-t-7'>
                            <div className='m-a-user-my-page-usage-table-item'>{formatDate(dac?.regDate)}</div>
                            <div className='m-a-user-my-page-usage-table-item'>{dac.cpNm}</div>
                            <div className='m-a-user-my-page-usage-table-item'>
                                {(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.cpPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>
                        </div>
                    ))}
                </div>

                {/*예치금&적립금탭 쿠폰 더보기버튼*/}
                {
                    dacDisplayLimits["coupon"] && sortedDacList && sortedDacList.filter(dac => dac.cpPrice > 0).length > dacDisplayLimits["coupon"] ?
                        <div className="m-t-20 m-b-50 user-center font-s-17">
                            <button onClick={() => handleMoreDacList("coupon")}
                                    className="moreBt1 m-r-8 wd-80 ht-35 font-c-default m-r-8 font-s-13">More
                            </button>
                        </div>
                        :
                        null
                }

            </div>
            <MFooterSection/>
            {deliveryDetailSt ?
                <MDeliveryPriceDetail deliveryDetailSt={deliveryDetailSt} deliveryDetailFalseFn={deliveryDetailFalseFn}
                                      selectedShip={payShipco}
                                      paySeqnum={paySeqnum} updateAppRecinfo={updateAppRecinfo}
                                      updatePayinfoList={updatePayinfoList} pathComponent={pathComponent}/>
                :
                isLoading ?
                    <CommonLoading/>
                    :
                    integPayDetailPopupSt ?
                        <IntegDetailPopup integDetailPopupClose={integDetailPopupClose}
                                          integPaySeqnum={integPaySeqnum}/>
                        :
                        downNoSelectSt ?
                            <MsgCheckModal downNoSelectSt={downNoSelectSt} closeDownNoSelect={closeDownNoSelect}/>
                            :
                            nonSelectedShow ?
                                <MsgCheckModal nonSelectedShow={nonSelectedShow}
                                               closeNonSelectedShow={closeNonSelectedShow}/>
                                :
                                unTrackNumSt ?
                                    <MsgCheckModal unTrackNumSt={unTrackNumSt} closeUnTrackNumSt={closeUnTrackNumSt}/>
                                    :
                                    null
            }
        </div>
    )
}

export default withAuth(MUserMyPg);
